
      /* <AUTO-GENERATED-SCRIPTS> */
  // Event emitted when an accordion item is closed.
        document.querySelector('#ifx-accordion-example ifx-accordion')?.addEventListener('ifxClose', (event) => {
          console.log('ifxClose:', event);
          // Add your custom handler logic here
        });

        // Event emitted when accordion is opened.
        document.querySelector('#ifx-accordion-example ifx-accordion')?.addEventListener('ifxOpen', (event) => {
          console.log('ifxOpen:', event);
          // Add your custom handler logic here
        });

        (() => {
          const section = document.getElementById('ifx-accordion-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-accordion-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"value","argKey":"ariaLevelNumber","propKey":"ariaLevelNumber","attrKey":"aria-level-number","controlType":"number","initialValue":3,"childSelector":"ifx-accordion-item"},{"kind":"boolean","argKey":"autoCollapse","propKey":"autoCollapse","attrKey":"auto-collapse","initial":false}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-accordion-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-accordion-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-accordion-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            // Event emitted when the main item area is clicked
        document.querySelector('#ifx-action-list-example ifx-action-list')?.addEventListener('ifxActionListItemClick', (event) => {
          console.log('ifxActionListItemClick:', event);
          // Add your custom handler logic here
        });

        (() => {
          const section = document.getElementById('ifx-action-list-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-action-list-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"value","argKey":"listAriaLabel","propKey":"listAriaLabel","attrKey":"list-aria-label","controlType":"text","initialValue":"Navigation menu"}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-action-list-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-action-list-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-action-list-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            // Event emitted when the component is closed.
        document.querySelector('#ifx-alert-example ifx-alert')?.addEventListener('ifxClose', (event) => {
          console.log('ifxClose:', event);
          // Add your custom handler logic here
        });

        (() => {
          const section = document.getElementById('ifx-alert-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-alert-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"options","argKey":"variant","propKey":"variant","attrKey":"variant","options":["primary","success","danger","warning"],"initialIndex":0},{"kind":"options","argKey":"icon","propKey":"icon","attrKey":"icon","options":["cartF16","ids16","addressBook16","advanced16","ai16","airplane16","antenna16","apartmentBuilding16","applications16","archive16","arrowDown16","arrowLeft16","arrowRight16","arrowTriangleDiagonal16","arrowTriangleDown16","arrowTriangleHorizontal16","arrowTriangleLeft16","arrowTriangleRight16","arrowTriangleUp16","arrowTriangleVertikal16","arrowUp16","assembledProduct16","attachment16","audioDescription16","availability16","award16","ban16","barGraph16","barGraphLinear16","barGraphX16","barcode16","batteryCharging16","beginner16","bell16","bellF16","bellX16","bike16","binoculars16","block16","blocks16","bluetooth16","board16","book16","bookBookmark16","bookOpen16","bookmark16","bookmarkF16","box16","braille16","briefcase16","bug16","bulletList16","cAdd16","cAddF16","cCheck16","cCheckF16","cDelete16","cDeleteF16","cInfo16","cInfoF16","cQuestion16","cQuestionF16","cRemove16","cRemoveF16","cWarning16","cWarningF16","calculator16","calendar16","calendarCheck16","calendarHeart16","calendarPlus16","camera16","car16","carLights16","card16","cart16","changeStatus16","charging16","chart16","chat16","check16","checkList16","checkedOutOther16","checkedOutYou16","chemistry16","chevronDown16","chevronLeft16","chevronRight16","chevronUp16","chip16","chipAi16","chipDip16","chips16","chocolateMenu16","chocolateMenuActive16","clipboard16","clipboardCheck16","clipboardMedical16","clock16","cloud16","cloudUploadDownload16","coach16","code16","cogwheel16","coins16","comment16","community16","configure16","contact16","copy16","copyright16","cornerArrowDownRight16","cross16","cssGidEuResidencePermit16","curvedArrowLeft16","curvedArrowRight16","cutlery16","dashboard16","database16","delete16","deleteForever16","deleteText16","desk16","desktop16","desktopScreen16","dot16","doubleChevronDown16","doubleChevronLeft16","doubleChevronRight16","doubleChevronUp16","download16","downloadCheck16","downloadPlus16","dragArrows16","dragIndicator16","duplicate16","eid16","editor16","elearning16","enlarge16","euc16","facebook","factory16","fairyWand16","feedbackSupport16","file16","fileAac16","fileAvi16","fileCss16","fileCsv16","fileDoc16","fileDocx16","fileEps16","fileExe16","fileGif16","fileHtml16","fileJpg16","fileJs16","fileJson16","fileMkv16","fileMov16","fileMp316","fileMp416","fileMpg16","fileOtf16","filePdf16","filePng16","filePpt16","filePptx16","fileRar16","fileRtf16","fileSap16","fileSql16","fileStp16","fileSvg16","fileText16","fileTxt16","fileVdf16","fileVdn16","fileVnd16","fileXlsx16","fileXml16","fileZip16","filter16","filterActive16","finance16","firewall16","flag16","flagF16","floppyDisk16","floppyDisks16","folder16","folderAdd16","folderEmpty16","folderOpen16","folderRemove16","fruitCrate16","gallery16","genericDiode16","github","glasses16","globe16","google","graduation16","grid16","gridLayout16","group16","gym16","halogenFree16","handshake16","happyBaby16","hashMark16","heading116","heading216","heading316","heading416","heading516","heading616","headset16","hide16","highReliablity16","history16","home16","hospital16","hospitalBed16","hourglass16","hyperlink16","image16","inbox16","instagram","insurance16","intermediate16","isolator16","key16","language16","laptop16","launch16","layers16","layout16","leadFree16","leaf16","license16","lifebuoy16","lightEmittingDiode16","lineGraph16","link16","linkedin","list16","listCheck16","listEdit16","listPlus16","listUser16","lock16","lockF16","logistics16","logout16","mail16","mapPin16","maximize16","medal16","mediaEject16","mediaPause16","mediaPlay16","mediaRecord16","mediaStop16","megaphone16","menu16","menuLeft16","menuRight16","microcontroller16","microcontrollerErase16","microcontrollerProgram16","microcontrollerSave16","microcontrollerVerify16","microphone16","minus16","mobileChat16","module16","money16","moon16","moonFilled16","more16","mouseCursor16","mouseCursorPointer16","mouseCursorText16","multiLineGraph16","myHr16","network16","orderedList16","organigram16","package16","paragraphs16","park16","passport16","pen16","people16","phone16","phoneCall16","pin16","pinF16","plus16","poll16","power16","preferences16","present16","preview16","printer16","procurement16","project16","protection16","qrCode16","qualified16","questionMark16","quote16","rateDown16","rateUp16","refresh16","reload16","reply16","restore16","roboticArm16","rocket16","rss16","sWarning16","sad16","sample16","satelite16","scale16","scissors16","search16","send16","server16","share16","shield16","shieldSettings16","show16","shuffle16","sidebarLeft16","sidebarRight16","simulation16","skipToBeginning16","skipToEnd16","smartphone16","smile16","snow16","software16","solution16","sound16","speaker16","splitView16","staircaseGraph16","star16","starF16","streetView16","stroller16","subscript16","superscript16","swapHorizontal16","swapVertical16","table16","tableX16","tag16","team16","technology16","temperature16","textBold16","textColor16","textItalic16","thumbDown16","thumbUp16","tool16","training16","tram16","transceiver16","translation16","treeStructure16","trendDown16","trendUp16","ungroup16","unlink16","unlocked16","unorderedList16","upload16","usb16","usbRemove16","usbToggle16","user16","userAdd16","userAdded16","userPin16","userRemove16","verified16","video16","videoCam16","videoCamX16","viewReplacement16","volumeDown16","volumeMute16","volumeUp16","wafer16","warning16","warningCritical16","warningCriticalF16","warningF16","waves16","webinar16","webpage16","wechat","weibo","wheelchair16","wifi16","windows16","xing","youku","youtube","zhihu","zoomIn16","zoomOut16"],"initialIndex":0},{"kind":"boolean","argKey":"closable","propKey":"closable","attrKey":"closable","initial":true},{"kind":"options","argKey":"AriaLiveText","propKey":"ariaLiveText","attrKey":"aria-live-text","options":["off","polite","assertive"],"initialIndex":2}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-alert-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-alert-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-alert-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            (() => {
          const section = document.getElementById('ifx-ai-label-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-ai-label-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"boolean","argKey":"divider","propKey":"divider","attrKey":"divider","initial":true},{"kind":"options","argKey":"variant","propKey":"variant","attrKey":"variant","options":["label","icon"],"initialIndex":0}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-ai-label-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-ai-label-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-ai-label-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            (() => {
          const section = document.getElementById('ifx-button-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-button-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"options","argKey":"icon","propKey":"icon","attrKey":"icon","options":["cartF16","ids16","addressBook16","advanced16","ai16","airplane16","antenna16","apartmentBuilding16","applications16","archive16","arrowDown16","arrowLeft16","arrowRight16","arrowTriangleDiagonal16","arrowTriangleDown16","arrowTriangleHorizontal16","arrowTriangleLeft16","arrowTriangleRight16","arrowTriangleUp16","arrowTriangleVertikal16","arrowUp16","assembledProduct16","attachment16","audioDescription16","availability16","award16","ban16","barGraph16","barGraphLinear16","barGraphX16","barcode16","batteryCharging16","beginner16","bell16","bellF16","bellX16","bike16","binoculars16","block16","blocks16","bluetooth16","board16","book16","bookBookmark16","bookOpen16","bookmark16","bookmarkF16","box16","braille16","briefcase16","bug16","bulletList16","cAdd16","cAddF16","cCheck16","cCheckF16","cDelete16","cDeleteF16","cInfo16","cInfoF16","cQuestion16","cQuestionF16","cRemove16","cRemoveF16","cWarning16","cWarningF16","calculator16","calendar16","calendarCheck16","calendarHeart16","calendarPlus16","camera16","car16","carLights16","card16","cart16","changeStatus16","charging16","chart16","chat16","check16","checkList16","checkedOutOther16","checkedOutYou16","chemistry16","chevronDown16","chevronLeft16","chevronRight16","chevronUp16","chip16","chipAi16","chipDip16","chips16","chocolateMenu16","chocolateMenuActive16","clipboard16","clipboardCheck16","clipboardMedical16","clock16","cloud16","cloudUploadDownload16","coach16","code16","cogwheel16","coins16","comment16","community16","configure16","contact16","copy16","copyright16","cornerArrowDownRight16","cross16","cssGidEuResidencePermit16","curvedArrowLeft16","curvedArrowRight16","cutlery16","dashboard16","database16","delete16","deleteForever16","deleteText16","desk16","desktop16","desktopScreen16","dot16","doubleChevronDown16","doubleChevronLeft16","doubleChevronRight16","doubleChevronUp16","download16","downloadCheck16","downloadPlus16","dragArrows16","dragIndicator16","duplicate16","eid16","editor16","elearning16","enlarge16","euc16","facebook","factory16","fairyWand16","feedbackSupport16","file16","fileAac16","fileAvi16","fileCss16","fileCsv16","fileDoc16","fileDocx16","fileEps16","fileExe16","fileGif16","fileHtml16","fileJpg16","fileJs16","fileJson16","fileMkv16","fileMov16","fileMp316","fileMp416","fileMpg16","fileOtf16","filePdf16","filePng16","filePpt16","filePptx16","fileRar16","fileRtf16","fileSap16","fileSql16","fileStp16","fileSvg16","fileText16","fileTxt16","fileVdf16","fileVdn16","fileVnd16","fileXlsx16","fileXml16","fileZip16","filter16","filterActive16","finance16","firewall16","flag16","flagF16","floppyDisk16","floppyDisks16","folder16","folderAdd16","folderEmpty16","folderOpen16","folderRemove16","fruitCrate16","gallery16","genericDiode16","github","glasses16","globe16","google","graduation16","grid16","gridLayout16","group16","gym16","halogenFree16","handshake16","happyBaby16","hashMark16","heading116","heading216","heading316","heading416","heading516","heading616","headset16","hide16","highReliablity16","history16","home16","hospital16","hospitalBed16","hourglass16","hyperlink16","image16","inbox16","instagram","insurance16","intermediate16","isolator16","key16","language16","laptop16","launch16","layers16","layout16","leadFree16","leaf16","license16","lifebuoy16","lightEmittingDiode16","lineGraph16","link16","linkedin","list16","listCheck16","listEdit16","listPlus16","listUser16","lock16","lockF16","logistics16","logout16","mail16","mapPin16","maximize16","medal16","mediaEject16","mediaPause16","mediaPlay16","mediaRecord16","mediaStop16","megaphone16","menu16","menuLeft16","menuRight16","microcontroller16","microcontrollerErase16","microcontrollerProgram16","microcontrollerSave16","microcontrollerVerify16","microphone16","minus16","mobileChat16","module16","money16","moon16","moonFilled16","more16","mouseCursor16","mouseCursorPointer16","mouseCursorText16","multiLineGraph16","myHr16","network16","orderedList16","organigram16","package16","paragraphs16","park16","passport16","pen16","people16","phone16","phoneCall16","pin16","pinF16","plus16","poll16","power16","preferences16","present16","preview16","printer16","procurement16","project16","protection16","qrCode16","qualified16","questionMark16","quote16","rateDown16","rateUp16","refresh16","reload16","reply16","restore16","roboticArm16","rocket16","rss16","sWarning16","sad16","sample16","satelite16","scale16","scissors16","search16","send16","server16","share16","shield16","shieldSettings16","show16","shuffle16","sidebarLeft16","sidebarRight16","simulation16","skipToBeginning16","skipToEnd16","smartphone16","smile16","snow16","software16","solution16","sound16","speaker16","splitView16","staircaseGraph16","star16","starF16","streetView16","stroller16","subscript16","superscript16","swapHorizontal16","swapVertical16","table16","tableX16","tag16","team16","technology16","temperature16","textBold16","textColor16","textItalic16","thumbDown16","thumbUp16","tool16","training16","tram16","transceiver16","translation16","treeStructure16","trendDown16","trendUp16","ungroup16","unlink16","unlocked16","unorderedList16","upload16","usb16","usbRemove16","usbToggle16","user16","userAdd16","userAdded16","userPin16","userRemove16","verified16","video16","videoCam16","videoCamX16","viewReplacement16","volumeDown16","volumeMute16","volumeUp16","wafer16","warning16","warningCritical16","warningCriticalF16","warningF16","waves16","webinar16","webpage16","wechat","weibo","wheelchair16","wifi16","windows16","xing","youku","youtube","zhihu","zoomIn16","zoomOut16"],"initialIndex":0},{"kind":"options","argKey":"variant","propKey":"variant","attrKey":"variant","options":["primary","secondary","tertiary"],"initialIndex":0},{"kind":"value","argKey":"ariaLabelText","propKey":"ariaLabelText","attrKey":"aria-label-text","controlType":"text","initialValue":"Button"},{"kind":"options","argKey":"theme","propKey":"theme","attrKey":"theme","options":["default","danger","inverse"],"initialIndex":0},{"kind":"options","argKey":"type","propKey":"type","attrKey":"type","options":["button","submit","reset"],"initialIndex":0},{"kind":"options","argKey":"size","propKey":"size","attrKey":"size","options":["xs","s","m","l"],"initialIndex":2},{"kind":"boolean","argKey":"fullWidth","propKey":"fullWidth","attrKey":"full-width","initial":false},{"kind":"boolean","argKey":"disabled","propKey":"disabled","attrKey":"disabled","initial":false},{"kind":"options","argKey":"iconPosition","propKey":"iconPosition","attrKey":"icon-position","options":["left","right"],"initialIndex":0},{"kind":"boolean","argKey":"href","propKey":"href","attrKey":"href","initial":false},{"kind":"options","argKey":"target","propKey":"target","attrKey":"target","options":["_blank","_self","_parent"],"initialIndex":0}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-button-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-button-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-button-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            // Emits the image position when it changes or is set.
        document.querySelector('#ifx-card-example ifx-card')?.addEventListener('imgPosition', (event) => {
          console.log('imgPosition:', event);
          // Add your custom handler logic here
        });

        (() => {
          const section = document.getElementById('ifx-card-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-card-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"options","argKey":"direction","propKey":"direction","attrKey":"direction","options":["horizontal","vertical"],"initialIndex":1},{"kind":"value","argKey":"ariaLabelText","propKey":"ariaLabelText","attrKey":"aria-label-text","controlType":"text","initialValue":"Card"},{"kind":"options","argKey":"position","propKey":"position","attrKey":"position","options":["left","right"],"initialIndex":1,"childSelector":"ifx-card-image"},{"kind":"value","argKey":"href","propKey":"href","attrKey":"href","controlType":"","initialValue":""},{"kind":"options","argKey":"target","propKey":"target","attrKey":"target","options":["_blank","_self","_parent"],"initialIndex":0},{"kind":"value","argKey":"src","propKey":"src","attrKey":"src","controlType":"","initialValue":"https://upload.wikimedia.org/wikipedia/commons/e/e4/Latte_and_dark_coffee.jpg","childSelector":"ifx-card-image"},{"kind":"value","argKey":"alt","propKey":"alt","attrKey":"alt","controlType":"","initialValue":"Coffee","childSelector":"ifx-card-image"},{"kind":"boolean","argKey":"fullWidth","propKey":"fullWidth","attrKey":"full-width","initial":false}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-card-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-card-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-card-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            // Event emitted when the checkbox state changes.
        // Emits the new checked state as a boolean value.
        document.querySelector('#ifx-checkbox-example ifx-checkbox')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

        // Event emitted when the error state changes.
        // Emits the new error state as a boolean value.
        document.querySelector('#ifx-checkbox-example ifx-checkbox')?.addEventListener('ifxError', (event) => {
          console.log('ifxError:', event);
          // Add your custom handler logic here
        });

        (() => {
          const section = document.getElementById('ifx-checkbox-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-checkbox-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"boolean","argKey":"error","propKey":"error","attrKey":"error","initial":false},{"kind":"boolean","argKey":"disabled","propKey":"disabled","attrKey":"disabled","initial":false},{"kind":"boolean","argKey":"checked","propKey":"checked","attrKey":"checked","initial":false},{"kind":"boolean","argKey":"indeterminate","propKey":"indeterminate","attrKey":"indeterminate","initial":false},{"kind":"options","argKey":"size","propKey":"size","attrKey":"size","options":["s","m"],"initialIndex":0},{"kind":"value","argKey":"name","propKey":"name","attrKey":"name","controlType":"","initialValue":"checkbox"}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-checkbox-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-checkbox-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-checkbox-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            // Event emitted when the checkbox state changes.
        // Emits the new checked state as a boolean value.
        document.querySelector('#ifx-checkbox-group-example ifx-checkbox-group')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

        // Event emitted when the error state changes.
        // Emits the new error state as a boolean value.
        document.querySelector('#ifx-checkbox-group-example ifx-checkbox-group')?.addEventListener('ifxError', (event) => {
          console.log('ifxError:', event);
          // Add your custom handler logic here
        });

        (() => {
          const section = document.getElementById('ifx-checkbox-group-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-checkbox-group-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"options","argKey":"alignment","propKey":"alignment","attrKey":"alignment","options":["vertical","horizontal"],"initialIndex":0},{"kind":"options","argKey":"size","propKey":"size","attrKey":"size","options":["s","m"],"initialIndex":1,"childSelector":"ifx-checkbox"},{"kind":"boolean","argKey":"checked","propKey":"checked","attrKey":"checked","initial":false,"childSelector":"ifx-checkbox"},{"kind":"boolean","argKey":"disabled","propKey":"disabled","attrKey":"disabled","initial":false,"childSelector":"ifx-checkbox"},{"kind":"boolean","argKey":"error","propKey":"error","attrKey":"error","initial":false,"childSelector":"ifx-checkbox"},{"kind":"boolean","argKey":"indeterminate","propKey":"indeterminate","attrKey":"indeterminate","initial":false,"childSelector":"ifx-checkbox"},{"kind":"boolean","argKey":"showGroupLabel","propKey":"showGroupLabel","attrKey":"show-group-label","initial":false},{"kind":"value","argKey":"groupLabelText","propKey":"groupLabelText","attrKey":"group-label-text","controlType":"text","initialValue":"Group Label"},{"kind":"boolean","argKey":"showCaption","propKey":"showCaption","attrKey":"show-caption","initial":false},{"kind":"value","argKey":"captionText","propKey":"captionText","attrKey":"caption-text","controlType":"text","initialValue":"Caption text, description, error notification"},{"kind":"boolean","argKey":"showCaptionIcon","propKey":"showCaptionIcon","attrKey":"show-caption-icon","initial":false},{"kind":"boolean","argKey":"required","propKey":"required","attrKey":"required","initial":false}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-checkbox-group-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-checkbox-group-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-checkbox-group-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            // Fires on selection change.
        document.querySelector('#ifx-chip-example ifx-chip')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

        // Emitted on chip select/deselect.
        document.querySelector('#ifx-chip-example ifx-chip')?.addEventListener('ifxChipItemSelect', (event) => {
          console.log('ifxChipItemSelect:', event);
          // Add your custom handler logic here
        });

        (() => {
          const section = document.getElementById('ifx-chip-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-chip-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"value","argKey":"placeholder","propKey":"placeholder","attrKey":"placeholder","controlType":"","initialValue":"Label"},{"kind":"options","argKey":"size","propKey":"size","attrKey":"size","options":["small","medium","large"],"initialIndex":1},{"kind":"options","argKey":"variant","propKey":"variant","attrKey":"variant","options":["single","multi"],"initialIndex":0},{"kind":"options","argKey":"theme","propKey":"theme","attrKey":"theme","options":["outlined","filled-light","filled-dark"],"initialIndex":0},{"kind":"boolean","argKey":"readOnly","propKey":"readOnly","attrKey":"read-only","initial":false},{"kind":"options","argKey":"icon","propKey":"icon","attrKey":"icon","options":["cartF16","ids16","addressBook16","advanced16","ai16","airplane16","antenna16","apartmentBuilding16","applications16","archive16","arrowDown16","arrowLeft16","arrowRight16","arrowTriangleDiagonal16","arrowTriangleDown16","arrowTriangleHorizontal16","arrowTriangleLeft16","arrowTriangleRight16","arrowTriangleUp16","arrowTriangleVertikal16","arrowUp16","assembledProduct16","attachment16","audioDescription16","availability16","award16","ban16","barGraph16","barGraphLinear16","barGraphX16","barcode16","batteryCharging16","beginner16","bell16","bellF16","bellX16","bike16","binoculars16","block16","blocks16","bluetooth16","board16","book16","bookBookmark16","bookOpen16","bookmark16","bookmarkF16","box16","braille16","briefcase16","bug16","bulletList16","cAdd16","cAddF16","cCheck16","cCheckF16","cDelete16","cDeleteF16","cInfo16","cInfoF16","cQuestion16","cQuestionF16","cRemove16","cRemoveF16","cWarning16","cWarningF16","calculator16","calendar16","calendarCheck16","calendarHeart16","calendarPlus16","camera16","car16","carLights16","card16","cart16","changeStatus16","charging16","chart16","chat16","check16","checkList16","checkedOutOther16","checkedOutYou16","chemistry16","chevronDown16","chevronLeft16","chevronRight16","chevronUp16","chip16","chipAi16","chipDip16","chips16","chocolateMenu16","chocolateMenuActive16","clipboard16","clipboardCheck16","clipboardMedical16","clock16","cloud16","cloudUploadDownload16","coach16","code16","cogwheel16","coins16","comment16","community16","configure16","contact16","copy16","copyright16","cornerArrowDownRight16","cross16","cssGidEuResidencePermit16","curvedArrowLeft16","curvedArrowRight16","cutlery16","dashboard16","database16","delete16","deleteForever16","deleteText16","desk16","desktop16","desktopScreen16","dot16","doubleChevronDown16","doubleChevronLeft16","doubleChevronRight16","doubleChevronUp16","download16","downloadCheck16","downloadPlus16","dragArrows16","dragIndicator16","duplicate16","eid16","editor16","elearning16","enlarge16","euc16","facebook","factory16","fairyWand16","feedbackSupport16","file16","fileAac16","fileAvi16","fileCss16","fileCsv16","fileDoc16","fileDocx16","fileEps16","fileExe16","fileGif16","fileHtml16","fileJpg16","fileJs16","fileJson16","fileMkv16","fileMov16","fileMp316","fileMp416","fileMpg16","fileOtf16","filePdf16","filePng16","filePpt16","filePptx16","fileRar16","fileRtf16","fileSap16","fileSql16","fileStp16","fileSvg16","fileText16","fileTxt16","fileVdf16","fileVdn16","fileVnd16","fileXlsx16","fileXml16","fileZip16","filter16","filterActive16","finance16","firewall16","flag16","flagF16","floppyDisk16","floppyDisks16","folder16","folderAdd16","folderEmpty16","folderOpen16","folderRemove16","fruitCrate16","gallery16","genericDiode16","github","glasses16","globe16","google","graduation16","grid16","gridLayout16","group16","gym16","halogenFree16","handshake16","happyBaby16","hashMark16","heading116","heading216","heading316","heading416","heading516","heading616","headset16","hide16","highReliablity16","history16","home16","hospital16","hospitalBed16","hourglass16","hyperlink16","image16","inbox16","instagram","insurance16","intermediate16","isolator16","key16","language16","laptop16","launch16","layers16","layout16","leadFree16","leaf16","license16","lifebuoy16","lightEmittingDiode16","lineGraph16","link16","linkedin","list16","listCheck16","listEdit16","listPlus16","listUser16","lock16","lockF16","logistics16","logout16","mail16","mapPin16","maximize16","medal16","mediaEject16","mediaPause16","mediaPlay16","mediaRecord16","mediaStop16","megaphone16","menu16","menuLeft16","menuRight16","microcontroller16","microcontrollerErase16","microcontrollerProgram16","microcontrollerSave16","microcontrollerVerify16","microphone16","minus16","mobileChat16","module16","money16","moon16","moonFilled16","more16","mouseCursor16","mouseCursorPointer16","mouseCursorText16","multiLineGraph16","myHr16","network16","orderedList16","organigram16","package16","paragraphs16","park16","passport16","pen16","people16","phone16","phoneCall16","pin16","pinF16","plus16","poll16","power16","preferences16","present16","preview16","printer16","procurement16","project16","protection16","qrCode16","qualified16","questionMark16","quote16","rateDown16","rateUp16","refresh16","reload16","reply16","restore16","roboticArm16","rocket16","rss16","sWarning16","sad16","sample16","satelite16","scale16","scissors16","search16","send16","server16","share16","shield16","shieldSettings16","show16","shuffle16","sidebarLeft16","sidebarRight16","simulation16","skipToBeginning16","skipToEnd16","smartphone16","smile16","snow16","software16","solution16","sound16","speaker16","splitView16","staircaseGraph16","star16","starF16","streetView16","stroller16","subscript16","superscript16","swapHorizontal16","swapVertical16","table16","tableX16","tag16","team16","technology16","temperature16","textBold16","textColor16","textItalic16","thumbDown16","thumbUp16","tool16","training16","tram16","transceiver16","translation16","treeStructure16","trendDown16","trendUp16","ungroup16","unlink16","unlocked16","unorderedList16","upload16","usb16","usbRemove16","usbToggle16","user16","userAdd16","userAdded16","userPin16","userRemove16","verified16","video16","videoCam16","videoCamX16","viewReplacement16","volumeDown16","volumeMute16","volumeUp16","wafer16","warning16","warningCritical16","warningCriticalF16","warningF16","waves16","webinar16","webpage16","wechat","weibo","wheelchair16","wifi16","windows16","xing","youku","youtube","zhihu","zoomIn16","zoomOut16"],"initialIndex":0},{"kind":"boolean","argKey":"disabled","propKey":"disabled","attrKey":"disabled","initial":false},{"kind":"boolean","argKey":"selected","propKey":"selected","attrKey":"selected","initial":false,"childSelector":"ifx-chip-item"},{"kind":"value","argKey":"value","propKey":"value","attrKey":"value","controlType":"","initialValue":"Item Value","childSelector":"ifx-chip-item"}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-chip-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-chip-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-chip-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            // Fired when the selected option changes.
        document.querySelector('#ifx-content-switcher-example ifx-content-switcher')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

        (() => {
          const section = document.getElementById('ifx-content-switcher-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-content-switcher-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"value","argKey":"value","propKey":"value","attrKey":"value","controlType":"text","initialValue":"item","childSelector":"ifx-content-switcher-item"},{"kind":"boolean","argKey":"selected","propKey":"selected","attrKey":"selected","initial":false,"childSelector":"ifx-content-switcher-item"},{"kind":"options","argKey":"icon","propKey":"icon","attrKey":"icon","options":["cartF16","ids16","addressBook16","advanced16","ai16","airplane16","antenna16","apartmentBuilding16","applications16","archive16","arrowDown16","arrowLeft16","arrowRight16","arrowTriangleDiagonal16","arrowTriangleDown16","arrowTriangleHorizontal16","arrowTriangleLeft16","arrowTriangleRight16","arrowTriangleUp16","arrowTriangleVertikal16","arrowUp16","assembledProduct16","attachment16","audioDescription16","availability16","award16","ban16","barGraph16","barGraphLinear16","barGraphX16","barcode16","batteryCharging16","beginner16","bell16","bellF16","bellX16","bike16","binoculars16","block16","blocks16","bluetooth16","board16","book16","bookBookmark16","bookOpen16","bookmark16","bookmarkF16","box16","braille16","briefcase16","bug16","bulletList16","cAdd16","cAddF16","cCheck16","cCheckF16","cDelete16","cDeleteF16","cInfo16","cInfoF16","cQuestion16","cQuestionF16","cRemove16","cRemoveF16","cWarning16","cWarningF16","calculator16","calendar16","calendarCheck16","calendarHeart16","calendarPlus16","camera16","car16","carLights16","card16","cart16","changeStatus16","charging16","chart16","chat16","check16","checkList16","checkedOutOther16","checkedOutYou16","chemistry16","chevronDown16","chevronLeft16","chevronRight16","chevronUp16","chip16","chipAi16","chipDip16","chips16","chocolateMenu16","chocolateMenuActive16","clipboard16","clipboardCheck16","clipboardMedical16","clock16","cloud16","cloudUploadDownload16","coach16","code16","cogwheel16","coins16","comment16","community16","configure16","contact16","copy16","copyright16","cornerArrowDownRight16","cross16","cssGidEuResidencePermit16","curvedArrowLeft16","curvedArrowRight16","cutlery16","dashboard16","database16","delete16","deleteForever16","deleteText16","desk16","desktop16","desktopScreen16","dot16","doubleChevronDown16","doubleChevronLeft16","doubleChevronRight16","doubleChevronUp16","download16","downloadCheck16","downloadPlus16","dragArrows16","dragIndicator16","duplicate16","eid16","editor16","elearning16","enlarge16","euc16","facebook","factory16","fairyWand16","feedbackSupport16","file16","fileAac16","fileAvi16","fileCss16","fileCsv16","fileDoc16","fileDocx16","fileEps16","fileExe16","fileGif16","fileHtml16","fileJpg16","fileJs16","fileJson16","fileMkv16","fileMov16","fileMp316","fileMp416","fileMpg16","fileOtf16","filePdf16","filePng16","filePpt16","filePptx16","fileRar16","fileRtf16","fileSap16","fileSql16","fileStp16","fileSvg16","fileText16","fileTxt16","fileVdf16","fileVdn16","fileVnd16","fileXlsx16","fileXml16","fileZip16","filter16","filterActive16","finance16","firewall16","flag16","flagF16","floppyDisk16","floppyDisks16","folder16","folderAdd16","folderEmpty16","folderOpen16","folderRemove16","fruitCrate16","gallery16","genericDiode16","github","glasses16","globe16","google","graduation16","grid16","gridLayout16","group16","gym16","halogenFree16","handshake16","happyBaby16","hashMark16","heading116","heading216","heading316","heading416","heading516","heading616","headset16","hide16","highReliablity16","history16","home16","hospital16","hospitalBed16","hourglass16","hyperlink16","image16","inbox16","instagram","insurance16","intermediate16","isolator16","key16","language16","laptop16","launch16","layers16","layout16","leadFree16","leaf16","license16","lifebuoy16","lightEmittingDiode16","lineGraph16","link16","linkedin","list16","listCheck16","listEdit16","listPlus16","listUser16","lock16","lockF16","logistics16","logout16","mail16","mapPin16","maximize16","medal16","mediaEject16","mediaPause16","mediaPlay16","mediaRecord16","mediaStop16","megaphone16","menu16","menuLeft16","menuRight16","microcontroller16","microcontrollerErase16","microcontrollerProgram16","microcontrollerSave16","microcontrollerVerify16","microphone16","minus16","mobileChat16","module16","money16","moon16","moonFilled16","more16","mouseCursor16","mouseCursorPointer16","mouseCursorText16","multiLineGraph16","myHr16","network16","orderedList16","organigram16","package16","paragraphs16","park16","passport16","pen16","people16","phone16","phoneCall16","pin16","pinF16","plus16","poll16","power16","preferences16","present16","preview16","printer16","procurement16","project16","protection16","qrCode16","qualified16","questionMark16","quote16","rateDown16","rateUp16","refresh16","reload16","reply16","restore16","roboticArm16","rocket16","rss16","sWarning16","sad16","sample16","satelite16","scale16","scissors16","search16","send16","server16","share16","shield16","shieldSettings16","show16","shuffle16","sidebarLeft16","sidebarRight16","simulation16","skipToBeginning16","skipToEnd16","smartphone16","smile16","snow16","software16","solution16","sound16","speaker16","splitView16","staircaseGraph16","star16","starF16","streetView16","stroller16","subscript16","superscript16","swapHorizontal16","swapVertical16","table16","tableX16","tag16","team16","technology16","temperature16","textBold16","textColor16","textItalic16","thumbDown16","thumbUp16","tool16","training16","tram16","transceiver16","translation16","treeStructure16","trendDown16","trendUp16","ungroup16","unlink16","unlocked16","unorderedList16","upload16","usb16","usbRemove16","usbToggle16","user16","userAdd16","userAdded16","userPin16","userRemove16","verified16","video16","videoCam16","videoCamX16","viewReplacement16","volumeDown16","volumeMute16","volumeUp16","wafer16","warning16","warningCritical16","warningCriticalF16","warningF16","waves16","webinar16","webpage16","wechat","weibo","wheelchair16","wifi16","windows16","xing","youku","youtube","zhihu","zoomIn16","zoomOut16"],"initialIndex":0,"childSelector":"ifx-icon"}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-content-switcher-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-content-switcher-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-content-switcher-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            // Event emitted when date value changes
        document.querySelector('#ifx-date-picker-example ifx-date-picker')?.addEventListener('ifxDate', (event) => {
          console.log('ifxDate:', event);
          // Add your custom handler logic here
        });

        (() => {
          const section = document.getElementById('ifx-date-picker-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-date-picker-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"value","argKey":"label","propKey":"label","attrKey":"label","controlType":"","initialValue":"Label Text"},{"kind":"value","argKey":"caption","propKey":"caption","attrKey":"caption","controlType":"","initialValue":"Caption text, description, error notification."},{"kind":"value","argKey":"min","propKey":"min","attrKey":"min","controlType":"","initialValue":""},{"kind":"value","argKey":"max","propKey":"max","attrKey":"max","controlType":"","initialValue":""},{"kind":"boolean","argKey":"disabled","propKey":"disabled","attrKey":"disabled","initial":false},{"kind":"boolean","argKey":"success","propKey":"success","attrKey":"success","initial":false},{"kind":"boolean","argKey":"error","propKey":"error","attrKey":"error","initial":false},{"kind":"options","argKey":"size","propKey":"size","attrKey":"size","options":["s","l"],"initialIndex":0},{"kind":"value","argKey":"value","propKey":"value","attrKey":"value","controlType":"","initialValue":""},{"kind":"value","argKey":"ariaLabelText","propKey":"ariaLabelText","attrKey":"aria-label-text","controlType":"text","initialValue":"Date Picker"},{"kind":"boolean","argKey":"required","propKey":"required","attrKey":"required","initial":false},{"kind":"value","argKey":"autocomplete","propKey":"autocomplete","attrKey":"autocomplete","controlType":"","initialValue":"on"},{"kind":"options","argKey":"type","propKey":"type","attrKey":"type","options":["date","datetime-local"],"initialIndex":0}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-date-picker-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-date-picker-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-date-picker-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            // Fired when dropdown closed.
        document.querySelector('#ifx-dropdown-example ifx-dropdown')?.addEventListener('ifxClose', (event) => {
          console.log('ifxClose:', event);
          // Add your custom handler logic here
        });

        // General dropdown event.
        document.querySelector('#ifx-dropdown-example ifx-dropdown')?.addEventListener('ifxDropdown', (event) => {
          console.log('ifxDropdown:', event);
          // Add your custom handler logic here
        });

        // Fired when dropdown open.
        document.querySelector('#ifx-dropdown-example ifx-dropdown')?.addEventListener('ifxOpen', (event) => {
          console.log('ifxOpen:', event);
          // Add your custom handler logic here
        });

        // Fired when a dropdown menu item is selected
        document.querySelector('#ifx-dropdown-example ifx-dropdown')?.addEventListener('ifxDropdownMenuItem', (event) => {
          console.log('ifxDropdownMenuItem:', event);
          // Add your custom handler logic here
        });

        // Emits the calculated size of the menu
        document.querySelector('#ifx-dropdown-example ifx-dropdown')?.addEventListener('menuSize', (event) => {
          console.log('menuSize:', event);
          // Add your custom handler logic here
        });

        (() => {
          const section = document.getElementById('ifx-dropdown-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-dropdown-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"options","argKey":"placement","propKey":"placement","attrKey":"placement","options":["auto","auto-start","auto-end","top","top-start","top-end","bottom","bottom-start","bottom-end","right","right-start","right-end","left","left-start","left-end"],"initialIndex":7},{"kind":"options","argKey":"size","propKey":"size","attrKey":"size","options":["s","m"],"initialIndex":1,"childSelector":"ifx-dropdown-menu"},{"kind":"boolean","argKey":"disabled","propKey":"disabled","attrKey":"disabled","initial":false},{"kind":"options","argKey":"variant","propKey":"variant","attrKey":"variant","options":["primary","secondary","tertiary"],"initialIndex":0,"childSelector":"ifx-dropdown-trigger-button"},{"kind":"boolean","argKey":"defaultOpen","propKey":"defaultOpen","attrKey":"default-open","initial":false},{"kind":"boolean","argKey":"noCloseOnOutsideClick","propKey":"noCloseOnOutsideClick","attrKey":"no-close-on-outside-click","initial":false},{"kind":"boolean","argKey":"noCloseOnMenuClick","propKey":"noCloseOnMenuClick","attrKey":"no-close-on-menu-click","initial":false},{"kind":"boolean","argKey":"noAppendToBody","propKey":"noAppendToBody","attrKey":"no-append-to-body","initial":true}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-dropdown-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-dropdown-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-dropdown-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            (() => {
          const section = document.getElementById('ifx-error-page-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-error-page-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"options","argKey":"type","propKey":"type","attrKey":"type","options":["403","404","503","maintenance"],"initialIndex":0},{"kind":"value","argKey":"illustrationUrl","propKey":"illustrationUrl","attrKey":"illustration-url","controlType":"text","initialValue":""},{"kind":"value","argKey":"imgAlt","propKey":"imgAlt","attrKey":"img-alt","controlType":"text","initialValue":""},{"kind":"value","argKey":"headline","propKey":"headline","attrKey":"headline","controlType":"text","initialValue":""},{"kind":"value","argKey":"description","propKey":"description","attrKey":"description","controlType":"text","initialValue":""}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-error-page-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-error-page-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-error-page-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            (() => {
          const section = document.getElementById('ifx-footer-example-medium');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-footer-example-medium-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"value","argKey":"copyrightText","propKey":"copyrightText","attrKey":"copyright-text","controlType":"text","initialValue":"© 1999 - 2026 Infineon Technologies AG"}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-footer-example-medium"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-footer-example-medium"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-footer-example-medium"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            (() => {
          const section = document.getElementById('ifx-icon-button-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-icon-button-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"options","argKey":"icon","propKey":"icon","attrKey":"icon","options":["cartF16","ids16","addressBook16","advanced16","ai16","airplane16","antenna16","apartmentBuilding16","applications16","archive16","arrowDown16","arrowLeft16","arrowRight16","arrowTriangleDiagonal16","arrowTriangleDown16","arrowTriangleHorizontal16","arrowTriangleLeft16","arrowTriangleRight16","arrowTriangleUp16","arrowTriangleVertikal16","arrowUp16","assembledProduct16","attachment16","audioDescription16","availability16","award16","ban16","barGraph16","barGraphLinear16","barGraphX16","barcode16","batteryCharging16","beginner16","bell16","bellF16","bellX16","bike16","binoculars16","block16","blocks16","bluetooth16","board16","book16","bookBookmark16","bookOpen16","bookmark16","bookmarkF16","box16","braille16","briefcase16","bug16","bulletList16","cAdd16","cAddF16","cCheck16","cCheckF16","cDelete16","cDeleteF16","cInfo16","cInfoF16","cQuestion16","cQuestionF16","cRemove16","cRemoveF16","cWarning16","cWarningF16","calculator16","calendar16","calendarCheck16","calendarHeart16","calendarPlus16","camera16","car16","carLights16","card16","cart16","changeStatus16","charging16","chart16","chat16","check16","checkList16","checkedOutOther16","checkedOutYou16","chemistry16","chevronDown16","chevronLeft16","chevronRight16","chevronUp16","chip16","chipAi16","chipDip16","chips16","chocolateMenu16","chocolateMenuActive16","clipboard16","clipboardCheck16","clipboardMedical16","clock16","cloud16","cloudUploadDownload16","coach16","code16","cogwheel16","coins16","comment16","community16","configure16","contact16","copy16","copyright16","cornerArrowDownRight16","cross16","cssGidEuResidencePermit16","curvedArrowLeft16","curvedArrowRight16","cutlery16","dashboard16","database16","delete16","deleteForever16","deleteText16","desk16","desktop16","desktopScreen16","dot16","doubleChevronDown16","doubleChevronLeft16","doubleChevronRight16","doubleChevronUp16","download16","downloadCheck16","downloadPlus16","dragArrows16","dragIndicator16","duplicate16","eid16","editor16","elearning16","enlarge16","euc16","facebook","factory16","fairyWand16","feedbackSupport16","file16","fileAac16","fileAvi16","fileCss16","fileCsv16","fileDoc16","fileDocx16","fileEps16","fileExe16","fileGif16","fileHtml16","fileJpg16","fileJs16","fileJson16","fileMkv16","fileMov16","fileMp316","fileMp416","fileMpg16","fileOtf16","filePdf16","filePng16","filePpt16","filePptx16","fileRar16","fileRtf16","fileSap16","fileSql16","fileStp16","fileSvg16","fileText16","fileTxt16","fileVdf16","fileVdn16","fileVnd16","fileXlsx16","fileXml16","fileZip16","filter16","filterActive16","finance16","firewall16","flag16","flagF16","floppyDisk16","floppyDisks16","folder16","folderAdd16","folderEmpty16","folderOpen16","folderRemove16","fruitCrate16","gallery16","genericDiode16","github","glasses16","globe16","google","graduation16","grid16","gridLayout16","group16","gym16","halogenFree16","handshake16","happyBaby16","hashMark16","heading116","heading216","heading316","heading416","heading516","heading616","headset16","hide16","highReliablity16","history16","home16","hospital16","hospitalBed16","hourglass16","hyperlink16","image16","inbox16","instagram","insurance16","intermediate16","isolator16","key16","language16","laptop16","launch16","layers16","layout16","leadFree16","leaf16","license16","lifebuoy16","lightEmittingDiode16","lineGraph16","link16","linkedin","list16","listCheck16","listEdit16","listPlus16","listUser16","lock16","lockF16","logistics16","logout16","mail16","mapPin16","maximize16","medal16","mediaEject16","mediaPause16","mediaPlay16","mediaRecord16","mediaStop16","megaphone16","menu16","menuLeft16","menuRight16","microcontroller16","microcontrollerErase16","microcontrollerProgram16","microcontrollerSave16","microcontrollerVerify16","microphone16","minus16","mobileChat16","module16","money16","moon16","moonFilled16","more16","mouseCursor16","mouseCursorPointer16","mouseCursorText16","multiLineGraph16","myHr16","network16","orderedList16","organigram16","package16","paragraphs16","park16","passport16","pen16","people16","phone16","phoneCall16","pin16","pinF16","plus16","poll16","power16","preferences16","present16","preview16","printer16","procurement16","project16","protection16","qrCode16","qualified16","questionMark16","quote16","rateDown16","rateUp16","refresh16","reload16","reply16","restore16","roboticArm16","rocket16","rss16","sWarning16","sad16","sample16","satelite16","scale16","scissors16","search16","send16","server16","share16","shield16","shieldSettings16","show16","shuffle16","sidebarLeft16","sidebarRight16","simulation16","skipToBeginning16","skipToEnd16","smartphone16","smile16","snow16","software16","solution16","sound16","speaker16","splitView16","staircaseGraph16","star16","starF16","streetView16","stroller16","subscript16","superscript16","swapHorizontal16","swapVertical16","table16","tableX16","tag16","team16","technology16","temperature16","textBold16","textColor16","textItalic16","thumbDown16","thumbUp16","tool16","training16","tram16","transceiver16","translation16","treeStructure16","trendDown16","trendUp16","ungroup16","unlink16","unlocked16","unorderedList16","upload16","usb16","usbRemove16","usbToggle16","user16","userAdd16","userAdded16","userPin16","userRemove16","verified16","video16","videoCam16","videoCamX16","viewReplacement16","volumeDown16","volumeMute16","volumeUp16","wafer16","warning16","warningCritical16","warningCriticalF16","warningF16","waves16","webinar16","webpage16","wechat","weibo","wheelchair16","wifi16","windows16","xing","youku","youtube","zhihu","zoomIn16","zoomOut16"],"initialIndex":0},{"kind":"options","argKey":"variant","propKey":"variant","attrKey":"variant","options":["primary","secondary","tertiary"],"initialIndex":0},{"kind":"boolean","argKey":"disabled","propKey":"disabled","attrKey":"disabled","initial":false},{"kind":"value","argKey":"href","propKey":"href","attrKey":"href","controlType":"","initialValue":""},{"kind":"options","argKey":"size","propKey":"size","attrKey":"size","options":["xs","s","m","l"],"initialIndex":2},{"kind":"options","argKey":"target","propKey":"target","attrKey":"target","options":["_blank","_self","_parent"],"initialIndex":0},{"kind":"options","argKey":"shape","propKey":"shape","attrKey":"shape","options":["round","square"],"initialIndex":0},{"kind":"value","argKey":"ariaLabelText","propKey":"ariaLabelText","attrKey":"aria-label-text","controlType":"text","initialValue":"Icon Button"}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-icon-button-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-icon-button-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-icon-button-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            (() => {
          const section = document.getElementById('ifx-indicator-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-indicator-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"boolean","argKey":"inverted","propKey":"inverted","attrKey":"inverted","initial":false}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-indicator-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-indicator-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-indicator-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            (() => {
          const section = document.getElementById('ifx-link-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-link-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"value","argKey":"href","propKey":"href","attrKey":"href","controlType":"","initialValue":""},{"kind":"options","argKey":"target","propKey":"target","attrKey":"target","options":["_blank","_self","_parent"],"initialIndex":0},{"kind":"boolean","argKey":"disabled","propKey":"disabled","attrKey":"disabled","initial":false},{"kind":"value","argKey":"download","propKey":"download","attrKey":"download","controlType":"","initialValue":""},{"kind":"options","argKey":"size","propKey":"size","attrKey":"size","options":["s","m","l","xl"],"initialIndex":1},{"kind":"options","argKey":"variant","propKey":"variant","attrKey":"variant","options":["bold","underlined","title","menu"],"initialIndex":0}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-link-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-link-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-link-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            // Fired when the mobile navbar menu is opened or closed.
        document.querySelector('#ifx-navbar-example ifx-navbar')?.addEventListener('ifxNavbarMobileMenuIsOpen', (event) => {
          console.log('ifxNavbarMobileMenuIsOpen:', event);
          // Add your custom handler logic here
        });

        // Fired when the navigation item is activated or clicked.
        document.querySelector('#ifx-navbar-example ifx-navbar')?.addEventListener('ifxNavItem', (event) => {
          console.log('ifxNavItem:', event);
          // Add your custom handler logic here
        });

        // Emits when the search input value changes.
        document.querySelector('#ifx-navbar-example ifx-navbar')?.addEventListener('ifxInput', (event) => {
          console.log('ifxInput:', event);
          // Add your custom handler logic here
        });

        // Emits when the search bar is opened or closed.
        // Payload is the new open state.
        document.querySelector('#ifx-navbar-example ifx-navbar')?.addEventListener('ifxOpen', (event) => {
          console.log('ifxOpen:', event);
          // Add your custom handler logic here
        });

        (() => {
          const section = document.getElementById('ifx-navbar-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-navbar-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"value","argKey":"applicationName","propKey":"applicationName","attrKey":"application-name","controlType":"text","initialValue":"Application name"},{"kind":"boolean","argKey":"showLogoAndAppname","propKey":"showLogoAndAppname","attrKey":"show-logo-and-appname","initial":true},{"kind":"value","argKey":"logoHref","propKey":"logoHref","attrKey":"logo-href","controlType":"text","initialValue":"http://google.com"},{"kind":"options","argKey":"logoHrefTarget","propKey":"logoHrefTarget","attrKey":"logo-href-target","options":["_self","_blank","_parent"],"initialIndex":0},{"kind":"boolean","argKey":"showLabelOfNavbarItem","propKey":"showLabelOfNavbarItem","attrKey":"show-label-of-navbar-item","initial":true,"childSelector":"ifx-navbar-item"},{"kind":"options","argKey":"iconOfNavbarItem","propKey":"iconOfNavbarItem","attrKey":"icon-of-navbar-item","options":["cartF16","ids16","addressBook16","advanced16","ai16","airplane16","antenna16","apartmentBuilding16","applications16","archive16","arrowDown16","arrowLeft16","arrowRight16","arrowTriangleDiagonal16","arrowTriangleDown16","arrowTriangleHorizontal16","arrowTriangleLeft16","arrowTriangleRight16","arrowTriangleUp16","arrowTriangleVertikal16","arrowUp16","assembledProduct16","attachment16","audioDescription16","availability16","award16","ban16","barGraph16","barGraphLinear16","barGraphX16","barcode16","batteryCharging16","beginner16","bell16","bellF16","bellX16","bike16","binoculars16","block16","blocks16","bluetooth16","board16","book16","bookBookmark16","bookOpen16","bookmark16","bookmarkF16","box16","braille16","briefcase16","bug16","bulletList16","cAdd16","cAddF16","cCheck16","cCheckF16","cDelete16","cDeleteF16","cInfo16","cInfoF16","cQuestion16","cQuestionF16","cRemove16","cRemoveF16","cWarning16","cWarningF16","calculator16","calendar16","calendarCheck16","calendarHeart16","calendarPlus16","camera16","car16","carLights16","card16","cart16","changeStatus16","charging16","chart16","chat16","check16","checkList16","checkedOutOther16","checkedOutYou16","chemistry16","chevronDown16","chevronLeft16","chevronRight16","chevronUp16","chip16","chipAi16","chipDip16","chips16","chocolateMenu16","chocolateMenuActive16","clipboard16","clipboardCheck16","clipboardMedical16","clock16","cloud16","cloudUploadDownload16","coach16","code16","cogwheel16","coins16","comment16","community16","configure16","contact16","copy16","copyright16","cornerArrowDownRight16","cross16","cssGidEuResidencePermit16","curvedArrowLeft16","curvedArrowRight16","cutlery16","dashboard16","database16","delete16","deleteForever16","deleteText16","desk16","desktop16","desktopScreen16","dot16","doubleChevronDown16","doubleChevronLeft16","doubleChevronRight16","doubleChevronUp16","download16","downloadCheck16","downloadPlus16","dragArrows16","dragIndicator16","duplicate16","eid16","editor16","elearning16","enlarge16","euc16","facebook","factory16","fairyWand16","feedbackSupport16","file16","fileAac16","fileAvi16","fileCss16","fileCsv16","fileDoc16","fileDocx16","fileEps16","fileExe16","fileGif16","fileHtml16","fileJpg16","fileJs16","fileJson16","fileMkv16","fileMov16","fileMp316","fileMp416","fileMpg16","fileOtf16","filePdf16","filePng16","filePpt16","filePptx16","fileRar16","fileRtf16","fileSap16","fileSql16","fileStp16","fileSvg16","fileText16","fileTxt16","fileVdf16","fileVdn16","fileVnd16","fileXlsx16","fileXml16","fileZip16","filter16","filterActive16","finance16","firewall16","flag16","flagF16","floppyDisk16","floppyDisks16","folder16","folderAdd16","folderEmpty16","folderOpen16","folderRemove16","fruitCrate16","gallery16","genericDiode16","github","glasses16","globe16","google","graduation16","grid16","gridLayout16","group16","gym16","halogenFree16","handshake16","happyBaby16","hashMark16","heading116","heading216","heading316","heading416","heading516","heading616","headset16","hide16","highReliablity16","history16","home16","hospital16","hospitalBed16","hourglass16","hyperlink16","image16","inbox16","instagram","insurance16","intermediate16","isolator16","key16","language16","laptop16","launch16","layers16","layout16","leadFree16","leaf16","license16","lifebuoy16","lightEmittingDiode16","lineGraph16","link16","linkedin","list16","listCheck16","listEdit16","listPlus16","listUser16","lock16","lockF16","logistics16","logout16","mail16","mapPin16","maximize16","medal16","mediaEject16","mediaPause16","mediaPlay16","mediaRecord16","mediaStop16","megaphone16","menu16","menuLeft16","menuRight16","microcontroller16","microcontrollerErase16","microcontrollerProgram16","microcontrollerSave16","microcontrollerVerify16","microphone16","minus16","mobileChat16","module16","money16","moon16","moonFilled16","more16","mouseCursor16","mouseCursorPointer16","mouseCursorText16","multiLineGraph16","myHr16","network16","orderedList16","organigram16","package16","paragraphs16","park16","passport16","pen16","people16","phone16","phoneCall16","pin16","pinF16","plus16","poll16","power16","preferences16","present16","preview16","printer16","procurement16","project16","protection16","qrCode16","qualified16","questionMark16","quote16","rateDown16","rateUp16","refresh16","reload16","reply16","restore16","roboticArm16","rocket16","rss16","sWarning16","sad16","sample16","satelite16","scale16","scissors16","search16","send16","server16","share16","shield16","shieldSettings16","show16","shuffle16","sidebarLeft16","sidebarRight16","simulation16","skipToBeginning16","skipToEnd16","smartphone16","smile16","snow16","software16","solution16","sound16","speaker16","splitView16","staircaseGraph16","star16","starF16","streetView16","stroller16","subscript16","superscript16","swapHorizontal16","swapVertical16","table16","tableX16","tag16","team16","technology16","temperature16","textBold16","textColor16","textItalic16","thumbDown16","thumbUp16","tool16","training16","tram16","transceiver16","translation16","treeStructure16","trendDown16","trendUp16","ungroup16","unlink16","unlocked16","unorderedList16","upload16","usb16","usbRemove16","usbToggle16","user16","userAdd16","userAdded16","userPin16","userRemove16","verified16","video16","videoCam16","videoCamX16","viewReplacement16","volumeDown16","volumeMute16","volumeUp16","wafer16","warning16","warningCritical16","warningCriticalF16","warningF16","waves16","webinar16","webpage16","wechat","weibo","wheelchair16","wifi16","windows16","xing","youku","youtube","zhihu","zoomIn16","zoomOut16"],"initialIndex":0,"childSelector":"ifx-navbar-item"},{"kind":"value","argKey":"numberIndicator","propKey":"numberIndicator","attrKey":"number-indicator","controlType":"number","initialValue":0,"childSelector":"ifx-navbar-item"},{"kind":"boolean","argKey":"dotIndicator","propKey":"dotIndicator","attrKey":"dot-indicator","initial":false,"childSelector":"ifx-navbar-item"},{"kind":"value","argKey":"hrefOfNavbarItem","propKey":"hrefOfNavbarItem","attrKey":"href-of-navbar-item","controlType":"text","initialValue":"","childSelector":"ifx-navbar-item"},{"kind":"options","argKey":"targetOfnavbarItem","propKey":"targetOfnavbarItem","attrKey":"target-ofnavbar-item","options":["_self"],"initialIndex":0,"childSelector":"ifx-navbar-item"},{"kind":"boolean","argKey":"hideOnMobile","propKey":"hideOnMobile","attrKey":"hide-on-mobile","initial":true,"childSelector":"ifx-navbar-item"},{"kind":"boolean","argKey":"showNavbarProfileLabel","propKey":"showNavbarProfileLabel","attrKey":"show-navbar-profile-label","initial":true,"childSelector":"ifx-navbar-profile"},{"kind":"value","argKey":"href","propKey":"href","attrKey":"href","controlType":"text","initialValue":"http://google.com","childSelector":"ifx-navbar-profile"},{"kind":"value","argKey":"profileImageUrl","propKey":"profileImageUrl","attrKey":"profile-image-url","controlType":"text","initialValue":"","childSelector":"ifx-navbar-profile"},{"kind":"options","argKey":"target","propKey":"target","attrKey":"target","options":["_self"],"initialIndex":0,"childSelector":"ifx-navbar-profile"},{"kind":"value","argKey":"alt","propKey":"alt","attrKey":"alt","controlType":"text","initialValue":"profile image","childSelector":"ifx-navbar-profile"},{"kind":"value","argKey":"userName","propKey":"userName","attrKey":"user-name","controlType":"text","initialValue":"","childSelector":"ifx-navbar-profile"},{"kind":"boolean","argKey":"searchBarIsOpen","propKey":"searchBarIsOpen","attrKey":"search-bar-is-open","initial":false,"childSelector":"ifx-search-bar"}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-navbar-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-navbar-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-navbar-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            // Emitted when collapsed state changes
        document.querySelector('#ifx-sidebar-example ifx-sidebar')?.addEventListener('ifxSidebarCollapseChange', (event) => {
          console.log('ifxSidebarCollapseChange:', event);
          // Add your custom handler logic here
        });

        // Emitted when logo image is clicked
        document.querySelector('#ifx-sidebar-example ifx-sidebar')?.addEventListener('ifxSidebarLogoClick', (event) => {
          console.log('ifxSidebarLogoClick:', event);
          // Add your custom handler logic here
        });

        // Event fired when an action item is clicked
        document.querySelector('#ifx-sidebar-example ifx-sidebar')?.addEventListener('ifxSidebarActionItem', (event) => {
          console.log('ifxSidebarActionItem:', event);
          // Add your custom handler logic here
        });

        // Event fired for menu item interactions
        document.querySelector('#ifx-sidebar-example ifx-sidebar')?.addEventListener('ifxSidebarMenu', (event) => {
          console.log('ifxSidebarMenu:', event);
          // Add your custom handler logic here
        });

        // Event fired when a navigation item is clicked
        document.querySelector('#ifx-sidebar-example ifx-sidebar')?.addEventListener('ifxSidebarNavigationItem', (event) => {
          console.log('ifxSidebarNavigationItem:', event);
          // Add your custom handler logic here
        });

        (() => {
          const section = document.getElementById('ifx-sidebar-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-sidebar-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"value","argKey":"applicationName","propKey":"applicationName","attrKey":"application-name","controlType":"","initialValue":"Application Name"},{"kind":"boolean","argKey":"showHeader","propKey":"showHeader","attrKey":"show-header","initial":true},{"kind":"boolean","argKey":"showFooter","propKey":"showFooter","attrKey":"show-footer","initial":true},{"kind":"boolean","argKey":"initialCollapse","propKey":"initialCollapse","attrKey":"initial-collapse","initial":true},{"kind":"boolean","argKey":"collapsed","propKey":"collapsed","attrKey":"collapsed","initial":false},{"kind":"boolean","argKey":"collapsible","propKey":"collapsible","attrKey":"collapsible","initial":false,"childSelector":"ifx-sidebar-item"},{"kind":"options","argKey":"position","propKey":"position","attrKey":"position","options":["left","right"],"initialIndex":0},{"kind":"value","argKey":"imprint","propKey":"imprint","attrKey":"imprint","controlType":"","initialValue":"https://yourwebsite.com/imprint"},{"kind":"value","argKey":"termsOfUse","propKey":"termsOfUse","attrKey":"terms-of-use","controlType":"","initialValue":"https://yourwebsite.com/terms"},{"kind":"value","argKey":"privacyPolicy","propKey":"privacyPolicy","attrKey":"privacy-policy","controlType":"","initialValue":"https://yourwebsite.com/privacy-policy"},{"kind":"value","argKey":"copyrightText","propKey":"copyrightText","attrKey":"copyright-text","controlType":"","initialValue":"© 1999 - 2026 Infineon Technologies AG"},{"kind":"options","argKey":"icon","propKey":"icon","attrKey":"icon","options":["cartF16","ids16","addressBook16","advanced16","ai16","airplane16","antenna16","apartmentBuilding16","applications16","archive16","arrowDown16","arrowLeft16","arrowRight16","arrowTriangleDiagonal16","arrowTriangleDown16","arrowTriangleHorizontal16","arrowTriangleLeft16","arrowTriangleRight16","arrowTriangleUp16","arrowTriangleVertikal16","arrowUp16","assembledProduct16","attachment16","audioDescription16","availability16","award16","ban16","barGraph16","barGraphLinear16","barGraphX16","barcode16","batteryCharging16","beginner16","bell16","bellF16","bellX16","bike16","binoculars16","block16","blocks16","bluetooth16","board16","book16","bookBookmark16","bookOpen16","bookmark16","bookmarkF16","box16","braille16","briefcase16","bug16","bulletList16","cAdd16","cAddF16","cCheck16","cCheckF16","cDelete16","cDeleteF16","cInfo16","cInfoF16","cQuestion16","cQuestionF16","cRemove16","cRemoveF16","cWarning16","cWarningF16","calculator16","calendar16","calendarCheck16","calendarHeart16","calendarPlus16","camera16","car16","carLights16","card16","cart16","changeStatus16","charging16","chart16","chat16","check16","checkList16","checkedOutOther16","checkedOutYou16","chemistry16","chevronDown16","chevronLeft16","chevronRight16","chevronUp16","chip16","chipAi16","chipDip16","chips16","chocolateMenu16","chocolateMenuActive16","clipboard16","clipboardCheck16","clipboardMedical16","clock16","cloud16","cloudUploadDownload16","coach16","code16","cogwheel16","coins16","comment16","community16","configure16","contact16","copy16","copyright16","cornerArrowDownRight16","cross16","cssGidEuResidencePermit16","curvedArrowLeft16","curvedArrowRight16","cutlery16","dashboard16","database16","delete16","deleteForever16","deleteText16","desk16","desktop16","desktopScreen16","dot16","doubleChevronDown16","doubleChevronLeft16","doubleChevronRight16","doubleChevronUp16","download16","downloadCheck16","downloadPlus16","dragArrows16","dragIndicator16","duplicate16","eid16","editor16","elearning16","enlarge16","euc16","facebook","factory16","fairyWand16","feedbackSupport16","file16","fileAac16","fileAvi16","fileCss16","fileCsv16","fileDoc16","fileDocx16","fileEps16","fileExe16","fileGif16","fileHtml16","fileJpg16","fileJs16","fileJson16","fileMkv16","fileMov16","fileMp316","fileMp416","fileMpg16","fileOtf16","filePdf16","filePng16","filePpt16","filePptx16","fileRar16","fileRtf16","fileSap16","fileSql16","fileStp16","fileSvg16","fileText16","fileTxt16","fileVdf16","fileVdn16","fileVnd16","fileXlsx16","fileXml16","fileZip16","filter16","filterActive16","finance16","firewall16","flag16","flagF16","floppyDisk16","floppyDisks16","folder16","folderAdd16","folderEmpty16","folderOpen16","folderRemove16","fruitCrate16","gallery16","genericDiode16","github","glasses16","globe16","google","graduation16","grid16","gridLayout16","group16","gym16","halogenFree16","handshake16","happyBaby16","hashMark16","heading116","heading216","heading316","heading416","heading516","heading616","headset16","hide16","highReliablity16","history16","home16","hospital16","hospitalBed16","hourglass16","hyperlink16","image16","inbox16","instagram","insurance16","intermediate16","isolator16","key16","language16","laptop16","launch16","layers16","layout16","leadFree16","leaf16","license16","lifebuoy16","lightEmittingDiode16","lineGraph16","link16","linkedin","list16","listCheck16","listEdit16","listPlus16","listUser16","lock16","lockF16","logistics16","logout16","mail16","mapPin16","maximize16","medal16","mediaEject16","mediaPause16","mediaPlay16","mediaRecord16","mediaStop16","megaphone16","menu16","menuLeft16","menuRight16","microcontroller16","microcontrollerErase16","microcontrollerProgram16","microcontrollerSave16","microcontrollerVerify16","microphone16","minus16","mobileChat16","module16","money16","moon16","moonFilled16","more16","mouseCursor16","mouseCursorPointer16","mouseCursorText16","multiLineGraph16","myHr16","network16","orderedList16","organigram16","package16","paragraphs16","park16","passport16","pen16","people16","phone16","phoneCall16","pin16","pinF16","plus16","poll16","power16","preferences16","present16","preview16","printer16","procurement16","project16","protection16","qrCode16","qualified16","questionMark16","quote16","rateDown16","rateUp16","refresh16","reload16","reply16","restore16","roboticArm16","rocket16","rss16","sWarning16","sad16","sample16","satelite16","scale16","scissors16","search16","send16","server16","share16","shield16","shieldSettings16","show16","shuffle16","sidebarLeft16","sidebarRight16","simulation16","skipToBeginning16","skipToEnd16","smartphone16","smile16","snow16","software16","solution16","sound16","speaker16","splitView16","staircaseGraph16","star16","starF16","streetView16","stroller16","subscript16","superscript16","swapHorizontal16","swapVertical16","table16","tableX16","tag16","team16","technology16","temperature16","textBold16","textColor16","textItalic16","thumbDown16","thumbUp16","tool16","training16","tram16","transceiver16","translation16","treeStructure16","trendDown16","trendUp16","ungroup16","unlink16","unlocked16","unorderedList16","upload16","usb16","usbRemove16","usbToggle16","user16","userAdd16","userAdded16","userPin16","userRemove16","verified16","video16","videoCam16","videoCamX16","viewReplacement16","volumeDown16","volumeMute16","volumeUp16","wafer16","warning16","warningCritical16","warningCriticalF16","warningF16","waves16","webinar16","webpage16","wechat","weibo","wheelchair16","wifi16","windows16","xing","youku","youtube","zhihu","zoomIn16","zoomOut16"],"initialIndex":0,"childSelector":"ifx-sidebar-item"},{"kind":"value","argKey":"hrefOfSidebarItem","propKey":"hrefOfSidebarItem","attrKey":"href-of-sidebar-item","controlType":"text","initialValue":"https://google.com","childSelector":"ifx-sidebar-item"},{"kind":"options","argKey":"targetOfSidebarItem","propKey":"targetOfSidebarItem","attrKey":"target-of-sidebar-item","options":["_self"],"initialIndex":0,"childSelector":"ifx-sidebar-item"},{"kind":"value","argKey":"numberIndicatorOfSidebarItem","propKey":"numberIndicatorOfSidebarItem","attrKey":"number-indicator-of-sidebar-item","controlType":"text","initialValue":"","childSelector":"ifx-sidebar-item"},{"kind":"boolean","argKey":"activeSidebarItem","propKey":"activeSidebarItem","attrKey":"active-sidebar-item","initial":false,"childSelector":"ifx-sidebar-item"},{"kind":"boolean","argKey":"isActionItem","propKey":"isActionItem","attrKey":"is-action-item","initial":false,"childSelector":"ifx-sidebar-item"},{"kind":"value","argKey":"hideMenuLabel","propKey":"hideMenuLabel","attrKey":"hide-menu-label","controlType":"text","initialValue":"Hide Menu","childSelector":"ifx-sidebar-item"},{"kind":"value","argKey":"logoHref","propKey":"logoHref","attrKey":"logo-href","controlType":"text","initialValue":"http://google.com"},{"kind":"options","argKey":"logoHrefTarget","propKey":"logoHrefTarget","attrKey":"logo-href-target","options":["_self","_blank","_parent"],"initialIndex":0},{"kind":"options","argKey":"footerHrefTarget","propKey":"footerHrefTarget","attrKey":"footer-href-target","options":["_self","_blank","_parent"],"initialIndex":1}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-sidebar-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-sidebar-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-sidebar-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            (() => {
          const section = document.getElementById('ifx-notification-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-notification-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"options","argKey":"variant","propKey":"variant","attrKey":"variant","options":["success","locked","error","neutral"],"initialIndex":0},{"kind":"options","argKey":"icon","propKey":"icon","attrKey":"icon","options":["cartF16","ids16","addressBook16","advanced16","ai16","airplane16","antenna16","apartmentBuilding16","applications16","archive16","arrowDown16","arrowLeft16","arrowRight16","arrowTriangleDiagonal16","arrowTriangleDown16","arrowTriangleHorizontal16","arrowTriangleLeft16","arrowTriangleRight16","arrowTriangleUp16","arrowTriangleVertikal16","arrowUp16","assembledProduct16","attachment16","audioDescription16","availability16","award16","ban16","barGraph16","barGraphLinear16","barGraphX16","barcode16","batteryCharging16","beginner16","bell16","bellF16","bellX16","bike16","binoculars16","block16","blocks16","bluetooth16","board16","book16","bookBookmark16","bookOpen16","bookmark16","bookmarkF16","box16","braille16","briefcase16","bug16","bulletList16","cAdd16","cAddF16","cCheck16","cCheckF16","cDelete16","cDeleteF16","cInfo16","cInfoF16","cQuestion16","cQuestionF16","cRemove16","cRemoveF16","cWarning16","cWarningF16","calculator16","calendar16","calendarCheck16","calendarHeart16","calendarPlus16","camera16","car16","carLights16","card16","cart16","changeStatus16","charging16","chart16","chat16","check16","checkList16","checkedOutOther16","checkedOutYou16","chemistry16","chevronDown16","chevronLeft16","chevronRight16","chevronUp16","chip16","chipAi16","chipDip16","chips16","chocolateMenu16","chocolateMenuActive16","clipboard16","clipboardCheck16","clipboardMedical16","clock16","cloud16","cloudUploadDownload16","coach16","code16","cogwheel16","coins16","comment16","community16","configure16","contact16","copy16","copyright16","cornerArrowDownRight16","cross16","cssGidEuResidencePermit16","curvedArrowLeft16","curvedArrowRight16","cutlery16","dashboard16","database16","delete16","deleteForever16","deleteText16","desk16","desktop16","desktopScreen16","dot16","doubleChevronDown16","doubleChevronLeft16","doubleChevronRight16","doubleChevronUp16","download16","downloadCheck16","downloadPlus16","dragArrows16","dragIndicator16","duplicate16","eid16","editor16","elearning16","enlarge16","euc16","facebook","factory16","fairyWand16","feedbackSupport16","file16","fileAac16","fileAvi16","fileCss16","fileCsv16","fileDoc16","fileDocx16","fileEps16","fileExe16","fileGif16","fileHtml16","fileJpg16","fileJs16","fileJson16","fileMkv16","fileMov16","fileMp316","fileMp416","fileMpg16","fileOtf16","filePdf16","filePng16","filePpt16","filePptx16","fileRar16","fileRtf16","fileSap16","fileSql16","fileStp16","fileSvg16","fileText16","fileTxt16","fileVdf16","fileVdn16","fileVnd16","fileXlsx16","fileXml16","fileZip16","filter16","filterActive16","finance16","firewall16","flag16","flagF16","floppyDisk16","floppyDisks16","folder16","folderAdd16","folderEmpty16","folderOpen16","folderRemove16","fruitCrate16","gallery16","genericDiode16","github","glasses16","globe16","google","graduation16","grid16","gridLayout16","group16","gym16","halogenFree16","handshake16","happyBaby16","hashMark16","heading116","heading216","heading316","heading416","heading516","heading616","headset16","hide16","highReliablity16","history16","home16","hospital16","hospitalBed16","hourglass16","hyperlink16","image16","inbox16","instagram","insurance16","intermediate16","isolator16","key16","language16","laptop16","launch16","layers16","layout16","leadFree16","leaf16","license16","lifebuoy16","lightEmittingDiode16","lineGraph16","link16","linkedin","list16","listCheck16","listEdit16","listPlus16","listUser16","lock16","lockF16","logistics16","logout16","mail16","mapPin16","maximize16","medal16","mediaEject16","mediaPause16","mediaPlay16","mediaRecord16","mediaStop16","megaphone16","menu16","menuLeft16","menuRight16","microcontroller16","microcontrollerErase16","microcontrollerProgram16","microcontrollerSave16","microcontrollerVerify16","microphone16","minus16","mobileChat16","module16","money16","moon16","moonFilled16","more16","mouseCursor16","mouseCursorPointer16","mouseCursorText16","multiLineGraph16","myHr16","network16","orderedList16","organigram16","package16","paragraphs16","park16","passport16","pen16","people16","phone16","phoneCall16","pin16","pinF16","plus16","poll16","power16","preferences16","present16","preview16","printer16","procurement16","project16","protection16","qrCode16","qualified16","questionMark16","quote16","rateDown16","rateUp16","refresh16","reload16","reply16","restore16","roboticArm16","rocket16","rss16","sWarning16","sad16","sample16","satelite16","scale16","scissors16","search16","send16","server16","share16","shield16","shieldSettings16","show16","shuffle16","sidebarLeft16","sidebarRight16","simulation16","skipToBeginning16","skipToEnd16","smartphone16","smile16","snow16","software16","solution16","sound16","speaker16","splitView16","staircaseGraph16","star16","starF16","streetView16","stroller16","subscript16","superscript16","swapHorizontal16","swapVertical16","table16","tableX16","tag16","team16","technology16","temperature16","textBold16","textColor16","textItalic16","thumbDown16","thumbUp16","tool16","training16","tram16","transceiver16","translation16","treeStructure16","trendDown16","trendUp16","ungroup16","unlink16","unlocked16","unorderedList16","upload16","usb16","usbRemove16","usbToggle16","user16","userAdd16","userAdded16","userPin16","userRemove16","verified16","video16","videoCam16","videoCamX16","viewReplacement16","volumeDown16","volumeMute16","volumeUp16","wafer16","warning16","warningCritical16","warningCriticalF16","warningF16","waves16","webinar16","webpage16","wechat","weibo","wheelchair16","wifi16","windows16","xing","youku","youtube","zhihu","zoomIn16","zoomOut16"],"initialIndex":0},{"kind":"value","argKey":"linkText","propKey":"linkText","attrKey":"link-text","controlType":"","initialValue":"Link"},{"kind":"value","argKey":"linkHref","propKey":"linkHref","attrKey":"link-href","controlType":"","initialValue":"https://www.example.com"},{"kind":"options","argKey":"linkTarget","propKey":"linkTarget","attrKey":"link-target","options":["_blank","_self","_parent"],"initialIndex":0}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-notification-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-notification-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-notification-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            // Emitted when the items-per-page value changes
        document.querySelector('#ifx-pagination-example ifx-pagination')?.addEventListener('ifxItemsPerPageChange', (event) => {
          console.log('ifxItemsPerPageChange:', event);
          // Add your custom handler logic here
        });

        // Emitted when the current page changes
        document.querySelector('#ifx-pagination-example ifx-pagination')?.addEventListener('ifxPageChange', (event) => {
          console.log('ifxPageChange:', event);
          // Add your custom handler logic here
        });

        (() => {
          const section = document.getElementById('ifx-pagination-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-pagination-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"value","argKey":"currentPage","propKey":"currentPage","attrKey":"current-page","controlType":"","initialValue":"1"},{"kind":"value","argKey":"total","propKey":"total","attrKey":"total","controlType":"","initialValue":"50"},{"kind":"value","argKey":"itemsPerPage","propKey":"itemsPerPage","attrKey":"items-per-page","controlType":"","initialValue":"[{\"value\":\"10\",\"selected\":true}, {\"value\":\"20\",\"selected\":false}, {\"value\":\"30\",\"selected\":false}, {\"value\":\"all\",\"selected\":false}]"},{"kind":"boolean","argKey":"showItemsPerPage","propKey":"showItemsPerPage","attrKey":"show-items-per-page","initial":true},{"kind":"value","argKey":"itemsPerPageLabel","propKey":"itemsPerPageLabel","attrKey":"items-per-page-label","controlType":"","initialValue":"Result per Pages"}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-pagination-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-pagination-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-pagination-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            (() => {
          const section = document.getElementById('ifx-progress-bar-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-progress-bar-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"value","argKey":"value","propKey":"value","attrKey":"value","controlType":"range","initialValue":50},{"kind":"boolean","argKey":"showLabel","propKey":"showLabel","attrKey":"show-label","initial":false},{"kind":"options","argKey":"size","propKey":"size","attrKey":"size","options":["s","m"],"initialIndex":1}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-progress-bar-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-progress-bar-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-progress-bar-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            // Fired when the checked state of the checkbox changes.
        document.querySelector('#ifx-radio-button-example ifx-radio-button')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

        // Fired when the checkbox enters or leaves an error state.
        document.querySelector('#ifx-radio-button-example ifx-radio-button')?.addEventListener('ifxError', (event) => {
          console.log('ifxError:', event);
          // Add your custom handler logic here
        });

        (() => {
          const section = document.getElementById('ifx-radio-button-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-radio-button-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"boolean","argKey":"error","propKey":"error","attrKey":"error","initial":false},{"kind":"boolean","argKey":"disabled","propKey":"disabled","attrKey":"disabled","initial":false},{"kind":"boolean","argKey":"checked","propKey":"checked","attrKey":"checked","initial":false},{"kind":"options","argKey":"size","propKey":"size","attrKey":"size","options":["s","m"],"initialIndex":0},{"kind":"value","argKey":"name","propKey":"name","attrKey":"name","controlType":"","initialValue":"radio-button"},{"kind":"value","argKey":"value","propKey":"value","attrKey":"value","controlType":"","initialValue":"radio"}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-radio-button-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-radio-button-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-radio-button-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            // Fired when the checked state of the checkbox changes.
        document.querySelector('#ifx-radio-button-group-example ifx-radio-button-group')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

        // Fired when the checkbox enters or leaves an error state.
        document.querySelector('#ifx-radio-button-group-example ifx-radio-button-group')?.addEventListener('ifxError', (event) => {
          console.log('ifxError:', event);
          // Add your custom handler logic here
        });

        (() => {
          const section = document.getElementById('ifx-radio-button-group-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-radio-button-group-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"options","argKey":"alignment","propKey":"alignment","attrKey":"alignment","options":["vertical","horizontal"],"initialIndex":0},{"kind":"options","argKey":"size","propKey":"size","attrKey":"size","options":["s","m"],"initialIndex":1,"childSelector":"ifx-radio-button"},{"kind":"boolean","argKey":"checked","propKey":"checked","attrKey":"checked","initial":false,"childSelector":"ifx-radio-button"},{"kind":"boolean","argKey":"disabled","propKey":"disabled","attrKey":"disabled","initial":false,"childSelector":"ifx-radio-button"},{"kind":"boolean","argKey":"error","propKey":"error","attrKey":"error","initial":false,"childSelector":"ifx-radio-button"},{"kind":"value","argKey":"name","propKey":"name","attrKey":"name","controlType":"text","initialValue":"radio-group","childSelector":"ifx-radio-button"},{"kind":"boolean","argKey":"showGroupLabel","propKey":"showGroupLabel","attrKey":"show-group-label","initial":false},{"kind":"value","argKey":"groupLabelText","propKey":"groupLabelText","attrKey":"group-label-text","controlType":"text","initialValue":"Group Label"},{"kind":"boolean","argKey":"showCaption","propKey":"showCaption","attrKey":"show-caption","initial":false},{"kind":"value","argKey":"captionText","propKey":"captionText","attrKey":"caption-text","controlType":"text","initialValue":"Caption text, description, error notification"},{"kind":"boolean","argKey":"showCaptionIcon","propKey":"showCaptionIcon","attrKey":"show-caption-icon","initial":false},{"kind":"boolean","argKey":"required","propKey":"required","attrKey":"required","initial":false}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-radio-button-group-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-radio-button-group-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-radio-button-group-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            // Emits when the search input value changes.
        document.querySelector('#ifx-search-bar-example ifx-search-bar')?.addEventListener('ifxInput', (event) => {
          console.log('ifxInput:', event);
          // Add your custom handler logic here
        });

        // Emits when the search bar is opened or closed.
        // Payload is the new open state.
        document.querySelector('#ifx-search-bar-example ifx-search-bar')?.addEventListener('ifxOpen', (event) => {
          console.log('ifxOpen:', event);
          // Add your custom handler logic here
        });

        (() => {
          const section = document.getElementById('ifx-search-bar-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-search-bar-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"boolean","argKey":"isOpen","propKey":"isOpen","attrKey":"is-open","initial":true},{"kind":"boolean","argKey":"disabled","propKey":"disabled","attrKey":"disabled","initial":false},{"kind":"value","argKey":"value","propKey":"value","attrKey":"value","controlType":"text","initialValue":""},{"kind":"value","argKey":"autocomplete","propKey":"autocomplete","attrKey":"autocomplete","controlType":"text","initialValue":"on"},{"kind":"value","argKey":"maxlength","propKey":"maxlength","attrKey":"maxlength","controlType":"number","initialValue":0},{"kind":"boolean","argKey":"showCloseButton","propKey":"showCloseButton","attrKey":"show-close-button","initial":true}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-search-bar-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-search-bar-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-search-bar-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            // Emitted when the input loses focus.
        document.querySelector('#ifx-search-field-example ifx-search-field')?.addEventListener('ifxBlur', (event) => {
          console.log('ifxBlur:', event);
          // Add your custom handler logic here
        });

        // Emitted when the input gains focus.
        document.querySelector('#ifx-search-field-example ifx-search-field')?.addEventListener('ifxFocus', (event) => {
          console.log('ifxFocus:', event);
          // Add your custom handler logic here
        });

        // Emitted on input change with the current value.
        document.querySelector('#ifx-search-field-example ifx-search-field')?.addEventListener('ifxInput', (event) => {
          console.log('ifxInput:', event);
          // Add your custom handler logic here
        });

        // Emitted to request external suggestions for the given query.
        document.querySelector('#ifx-search-field-example ifx-search-field')?.addEventListener('ifxSuggestionRequested', (event) => {
          console.log('ifxSuggestionRequested:', event);
          // Add your custom handler logic here
        });

        // Emitted when a suggestion or history item is selected.
        document.querySelector('#ifx-search-field-example ifx-search-field')?.addEventListener('ifxSuggestionSelected', (event) => {
          console.log('ifxSuggestionSelected:', event);
          // Add your custom handler logic here
        });

        (() => {
          const section = document.getElementById('ifx-search-field-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-search-field-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"boolean","argKey":"showDeleteIcon","propKey":"showDeleteIcon","attrKey":"show-delete-icon","initial":true},{"kind":"boolean","argKey":"disabled","propKey":"disabled","attrKey":"disabled","initial":false},{"kind":"options","argKey":"size","propKey":"size","attrKey":"size","options":["s","m"],"initialIndex":1},{"kind":"value","argKey":"placeholder","propKey":"placeholder","attrKey":"placeholder","controlType":"text","initialValue":"Search..."},{"kind":"value","argKey":"maxlength","propKey":"maxlength","attrKey":"maxlength","controlType":"number","initialValue":0},{"kind":"value","argKey":"value","propKey":"value","attrKey":"value","controlType":"text","initialValue":""},{"kind":"value","argKey":"autocomplete","propKey":"autocomplete","attrKey":"autocomplete","controlType":"text","initialValue":"on"},{"kind":"boolean","argKey":"showSuggestions","propKey":"showSuggestions","attrKey":"show-suggestions","initial":false},{"kind":"boolean","argKey":"enableHistory","propKey":"enableHistory","attrKey":"enable-history","initial":true},{"kind":"value","argKey":"maxSuggestions","propKey":"maxSuggestions","attrKey":"max-suggestions","controlType":"number","initialValue":10},{"kind":"value","argKey":"maxHistoryItems","propKey":"maxHistoryItems","attrKey":"max-history-items","controlType":"number","initialValue":5},{"kind":"value","argKey":"historyKey","propKey":"historyKey","attrKey":"history-key","controlType":"text","initialValue":"ifx-search-history"},{"kind":"value","argKey":"historyHeaderText","propKey":"historyHeaderText","attrKey":"history-header-text","controlType":"text","initialValue":"Recent Searches"},{"kind":"value","argKey":"ariaLabelText","propKey":"ariaLabelText","attrKey":"aria-label-text","controlType":"text","initialValue":"Search field"},{"kind":"value","argKey":"ariaLabelledBy","propKey":"ariaLabelledBy","attrKey":"aria-labelled-by","controlType":"text","initialValue":""},{"kind":"value","argKey":"ariaDescribedBy","propKey":"ariaDescribedBy","attrKey":"aria-described-by","controlType":"text","initialValue":""},{"kind":"value","argKey":"deleteIconAriaLabel","propKey":"deleteIconAriaLabel","attrKey":"delete-icon-aria-label","controlType":"text","initialValue":"Clear search"},{"kind":"value","argKey":"historyDeleteAriaLabel","propKey":"historyDeleteAriaLabel","attrKey":"history-delete-aria-label","controlType":"text","initialValue":"Remove from history"},{"kind":"value","argKey":"dropdownAriaLabel","propKey":"dropdownAriaLabel","attrKey":"dropdown-aria-label","controlType":"text","initialValue":"Search suggestions and history"},{"kind":"value","argKey":"suggestionAriaLabel","propKey":"suggestionAriaLabel","attrKey":"suggestion-aria-label","controlType":"text","initialValue":"Search suggestion"},{"kind":"value","argKey":"historyItemAriaLabel","propKey":"historyItemAriaLabel","attrKey":"history-item-aria-label","controlType":"text","initialValue":"Search history item"}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-search-field-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-search-field-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-search-field-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            // Fired when the selected segment changes (previous and new value).
        document.querySelector('#ifx-segmented-control-example ifx-segmented-control')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

        // Fired when this segment is selected (emits the segment index).
        document.querySelector('#ifx-segmented-control-example ifx-segmented-control')?.addEventListener('segmentSelect', (event) => {
          console.log('segmentSelect:', event);
          // Add your custom handler logic here
        });

        (() => {
          const section = document.getElementById('ifx-segmented-control-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-segmented-control-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"value","argKey":"caption","propKey":"caption","attrKey":"caption","controlType":"","initialValue":"Caption text to describe the controls"},{"kind":"value","argKey":"label","propKey":"label","attrKey":"label","controlType":"","initialValue":"Group Label"},{"kind":"options","argKey":"size","propKey":"size","attrKey":"size","options":["regular","small"],"initialIndex":0},{"kind":"options","argKey":"icon","propKey":"icon","attrKey":"icon","options":["cartF16","ids16","addressBook16","advanced16","ai16","airplane16","antenna16","apartmentBuilding16","applications16","archive16","arrowDown16","arrowLeft16","arrowRight16","arrowTriangleDiagonal16","arrowTriangleDown16","arrowTriangleHorizontal16","arrowTriangleLeft16","arrowTriangleRight16","arrowTriangleUp16","arrowTriangleVertikal16","arrowUp16","assembledProduct16","attachment16","audioDescription16","availability16","award16","ban16","barGraph16","barGraphLinear16","barGraphX16","barcode16","batteryCharging16","beginner16","bell16","bellF16","bellX16","bike16","binoculars16","block16","blocks16","bluetooth16","board16","book16","bookBookmark16","bookOpen16","bookmark16","bookmarkF16","box16","braille16","briefcase16","bug16","bulletList16","cAdd16","cAddF16","cCheck16","cCheckF16","cDelete16","cDeleteF16","cInfo16","cInfoF16","cQuestion16","cQuestionF16","cRemove16","cRemoveF16","cWarning16","cWarningF16","calculator16","calendar16","calendarCheck16","calendarHeart16","calendarPlus16","camera16","car16","carLights16","card16","cart16","changeStatus16","charging16","chart16","chat16","check16","checkList16","checkedOutOther16","checkedOutYou16","chemistry16","chevronDown16","chevronLeft16","chevronRight16","chevronUp16","chip16","chipAi16","chipDip16","chips16","chocolateMenu16","chocolateMenuActive16","clipboard16","clipboardCheck16","clipboardMedical16","clock16","cloud16","cloudUploadDownload16","coach16","code16","cogwheel16","coins16","comment16","community16","configure16","contact16","copy16","copyright16","cornerArrowDownRight16","cross16","cssGidEuResidencePermit16","curvedArrowLeft16","curvedArrowRight16","cutlery16","dashboard16","database16","delete16","deleteForever16","deleteText16","desk16","desktop16","desktopScreen16","dot16","doubleChevronDown16","doubleChevronLeft16","doubleChevronRight16","doubleChevronUp16","download16","downloadCheck16","downloadPlus16","dragArrows16","dragIndicator16","duplicate16","eid16","editor16","elearning16","enlarge16","euc16","facebook","factory16","fairyWand16","feedbackSupport16","file16","fileAac16","fileAvi16","fileCss16","fileCsv16","fileDoc16","fileDocx16","fileEps16","fileExe16","fileGif16","fileHtml16","fileJpg16","fileJs16","fileJson16","fileMkv16","fileMov16","fileMp316","fileMp416","fileMpg16","fileOtf16","filePdf16","filePng16","filePpt16","filePptx16","fileRar16","fileRtf16","fileSap16","fileSql16","fileStp16","fileSvg16","fileText16","fileTxt16","fileVdf16","fileVdn16","fileVnd16","fileXlsx16","fileXml16","fileZip16","filter16","filterActive16","finance16","firewall16","flag16","flagF16","floppyDisk16","floppyDisks16","folder16","folderAdd16","folderEmpty16","folderOpen16","folderRemove16","fruitCrate16","gallery16","genericDiode16","github","glasses16","globe16","google","graduation16","grid16","gridLayout16","group16","gym16","halogenFree16","handshake16","happyBaby16","hashMark16","heading116","heading216","heading316","heading416","heading516","heading616","headset16","hide16","highReliablity16","history16","home16","hospital16","hospitalBed16","hourglass16","hyperlink16","image16","inbox16","instagram","insurance16","intermediate16","isolator16","key16","language16","laptop16","launch16","layers16","layout16","leadFree16","leaf16","license16","lifebuoy16","lightEmittingDiode16","lineGraph16","link16","linkedin","list16","listCheck16","listEdit16","listPlus16","listUser16","lock16","lockF16","logistics16","logout16","mail16","mapPin16","maximize16","medal16","mediaEject16","mediaPause16","mediaPlay16","mediaRecord16","mediaStop16","megaphone16","menu16","menuLeft16","menuRight16","microcontroller16","microcontrollerErase16","microcontrollerProgram16","microcontrollerSave16","microcontrollerVerify16","microphone16","minus16","mobileChat16","module16","money16","moon16","moonFilled16","more16","mouseCursor16","mouseCursorPointer16","mouseCursorText16","multiLineGraph16","myHr16","network16","orderedList16","organigram16","package16","paragraphs16","park16","passport16","pen16","people16","phone16","phoneCall16","pin16","pinF16","plus16","poll16","power16","preferences16","present16","preview16","printer16","procurement16","project16","protection16","qrCode16","qualified16","questionMark16","quote16","rateDown16","rateUp16","refresh16","reload16","reply16","restore16","roboticArm16","rocket16","rss16","sWarning16","sad16","sample16","satelite16","scale16","scissors16","search16","send16","server16","share16","shield16","shieldSettings16","show16","shuffle16","sidebarLeft16","sidebarRight16","simulation16","skipToBeginning16","skipToEnd16","smartphone16","smile16","snow16","software16","solution16","sound16","speaker16","splitView16","staircaseGraph16","star16","starF16","streetView16","stroller16","subscript16","superscript16","swapHorizontal16","swapVertical16","table16","tableX16","tag16","team16","technology16","temperature16","textBold16","textColor16","textItalic16","thumbDown16","thumbUp16","tool16","training16","tram16","transceiver16","translation16","treeStructure16","trendDown16","trendUp16","ungroup16","unlink16","unlocked16","unorderedList16","upload16","usb16","usbRemove16","usbToggle16","user16","userAdd16","userAdded16","userPin16","userRemove16","verified16","video16","videoCam16","videoCamX16","viewReplacement16","volumeDown16","volumeMute16","volumeUp16","wafer16","warning16","warningCritical16","warningCriticalF16","warningF16","waves16","webinar16","webpage16","wechat","weibo","wheelchair16","wifi16","windows16","xing","youku","youtube","zhihu","zoomIn16","zoomOut16"],"initialIndex":0,"childSelector":"ifx-segment"},{"kind":"boolean","argKey":"selected","propKey":"selected","attrKey":"selected","initial":true,"childSelector":"ifx-segment"},{"kind":"value","argKey":"value","propKey":"value","attrKey":"value","controlType":"","initialValue":"Value","childSelector":"ifx-segment"},{"kind":"boolean","argKey":"error","propKey":"error","attrKey":"error","initial":false},{"kind":"boolean","argKey":"required","propKey":"required","attrKey":"required","initial":false}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-segmented-control-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-segmented-control-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-segmented-control-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            // Fired when the input / search value changes.
        document.querySelector('#ifx-select-example ifx-select')?.addEventListener('ifxInput', (event) => {
          console.log('ifxInput:', event);
          // Add your custom handler logic here
        });

        // Fired when an option is selected.
        document.querySelector('#ifx-select-example ifx-select')?.addEventListener('ifxSelect', (event) => {
          console.log('ifxSelect:', event);
          // Add your custom handler logic here
        });

        (() => {
          const section = document.getElementById('ifx-select-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-select-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"options","argKey":"size","propKey":"size","attrKey":"size","options":["s","m"],"initialIndex":1},{"kind":"boolean","argKey":"placeholder","propKey":"placeholder","attrKey":"placeholder","initial":true},{"kind":"value","argKey":"placeholderValue","propKey":"placeholderValue","attrKey":"placeholder-value","controlType":"","initialValue":"Placeholder"},{"kind":"boolean","argKey":"error","propKey":"error","attrKey":"error","initial":false},{"kind":"value","argKey":"label","propKey":"label","attrKey":"label","controlType":"","initialValue":""},{"kind":"boolean","argKey":"disabled","propKey":"disabled","attrKey":"disabled","initial":false},{"kind":"value","argKey":"caption","propKey":"caption","attrKey":"caption","controlType":"","initialValue":""},{"kind":"boolean","argKey":"required","propKey":"required","attrKey":"required","initial":true},{"kind":"boolean","argKey":"showSearch","propKey":"showSearch","attrKey":"show-search","initial":true},{"kind":"boolean","argKey":"showClearButton","propKey":"showClearButton","attrKey":"show-clear-button","initial":true},{"kind":"value","argKey":"searchPlaceholderValue","propKey":"searchPlaceholderValue","attrKey":"search-placeholder-value","controlType":"","initialValue":"Search..."},{"kind":"value","argKey":"options","propKey":"options","attrKey":"options","controlType":"","initialValue":"[{\"value\":\"a\",\"label\":\"option a\",\"selected\":false},{\"value\":\"b\",\"label\":\"option b\",\"selected\":false},{\"value\":\"c\",\"label\":\"option c\",\"selected\":false}]"}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-select-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-select-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-select-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            (() => {
          const section = document.getElementById('ifx-spinner-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-spinner-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"options","argKey":"size","propKey":"size","attrKey":"size","options":["s","m"],"initialIndex":1},{"kind":"options","argKey":"variant","propKey":"variant","attrKey":"variant","options":["default","brand"],"initialIndex":0},{"kind":"boolean","argKey":"inverted","propKey":"inverted","attrKey":"inverted","initial":false},{"kind":"value","argKey":"ariaLabelText","propKey":"ariaLabelText","attrKey":"aria-label-text","controlType":"text","initialValue":""}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-spinner-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-spinner-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-spinner-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            (() => {
          const section = document.getElementById('ifx-status-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-status-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"value","argKey":"label","propKey":"label","attrKey":"label","controlType":"","initialValue":"text"},{"kind":"boolean","argKey":"border","propKey":"border","attrKey":"border","initial":true},{"kind":"options","argKey":"color","propKey":"color","attrKey":"color","options":["engineering-100","engineering-200","engineering-300","engineering-400","engineering-500","engineering-600","ocean-100","ocean-200","ocean-300","ocean-400","ocean-500","ocean-600","ocean-700","red-500","red-600","red-700","orange-500","green-500","lawn-400","lawn-500","lawn-700","berry-400","berry-500","sun-400","sun-500","sand-400","sand-500"],"initialIndex":16}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-status-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-status-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-status-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            // Fired when the active step changes.
        document.querySelector('#ifx-stepper-example ifx-stepper')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

        (() => {
          const section = document.getElementById('ifx-stepper-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-stepper-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"value","argKey":"activeStep","propKey":"activeStep","attrKey":"active-step","controlType":"number","initialValue":2},{"kind":"boolean","argKey":"completeStep","propKey":"completeStep","attrKey":"complete-step","initial":false,"childSelector":"ifx-step"},{"kind":"boolean","argKey":"disabled","propKey":"disabled","attrKey":"disabled","initial":false,"childSelector":"ifx-step"},{"kind":"boolean","argKey":"error","propKey":"error","attrKey":"error","initial":false,"childSelector":"ifx-step"},{"kind":"options","argKey":"indicatorPosition","propKey":"indicatorPosition","attrKey":"indicator-position","options":["left","right"],"initialIndex":0},{"kind":"boolean","argKey":"showStepNumber","propKey":"showStepNumber","attrKey":"show-step-number","initial":false},{"kind":"options","argKey":"variant","propKey":"variant","attrKey":"variant","options":["default","compact","vertical"],"initialIndex":0},{"kind":"value","argKey":"ariaLabelText","propKey":"ariaLabelText","attrKey":"aria-label-text","controlType":"text","initialValue":""},{"kind":"value","argKey":"ariaCurrentText","propKey":"ariaCurrentText","attrKey":"aria-current-text","controlType":"text","initialValue":""}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-stepper-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-stepper-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-stepper-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            // Fired when the active step changes.
        document.querySelector('#ifx-stepper-example-compact ifx-stepper')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

        (() => {
          const section = document.getElementById('ifx-stepper-example-compact');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-stepper-example-compact-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"value","argKey":"activeStep","propKey":"activeStep","attrKey":"active-step","controlType":"number","initialValue":2},{"kind":"boolean","argKey":"completeStep","propKey":"completeStep","attrKey":"complete-step","initial":false,"childSelector":"ifx-step"},{"kind":"boolean","argKey":"disabled","propKey":"disabled","attrKey":"disabled","initial":false,"childSelector":"ifx-step"},{"kind":"boolean","argKey":"error","propKey":"error","attrKey":"error","initial":false,"childSelector":"ifx-step"},{"kind":"options","argKey":"indicatorPosition","propKey":"indicatorPosition","attrKey":"indicator-position","options":["left","right"],"initialIndex":0},{"kind":"boolean","argKey":"showStepNumber","propKey":"showStepNumber","attrKey":"show-step-number","initial":false},{"kind":"options","argKey":"variant","propKey":"variant","attrKey":"variant","options":["default","compact","vertical"],"initialIndex":1},{"kind":"value","argKey":"ariaLabelText","propKey":"ariaLabelText","attrKey":"aria-label-text","controlType":"text","initialValue":""},{"kind":"value","argKey":"ariaCurrentText","propKey":"ariaCurrentText","attrKey":"aria-current-text","controlType":"text","initialValue":""}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-stepper-example-compact"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-stepper-example-compact"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-stepper-example-compact"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            // Emitted when checked state changes.
        document.querySelector('#ifx-switch-example ifx-switch')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

        (() => {
          const section = document.getElementById('ifx-switch-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-switch-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"value","argKey":"name","propKey":"name","attrKey":"name","controlType":"","initialValue":"switch"},{"kind":"boolean","argKey":"checked","propKey":"checked","attrKey":"checked","initial":false},{"kind":"value","argKey":"value","propKey":"value","attrKey":"value","controlType":"","initialValue":"on"},{"kind":"boolean","argKey":"disabled","propKey":"disabled","attrKey":"disabled","initial":false}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-switch-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-switch-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-switch-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            (() => {
          const section = document.getElementById('ifx-basic-table-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-basic-table-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"value","argKey":"tableHeight","propKey":"tableHeight","attrKey":"table-height","controlType":"","initialValue":"auto","childSelector":"ifx-table"},{"kind":"options","argKey":"rowHeight","propKey":"rowHeight","attrKey":"row-height","options":["compact","default"],"initialIndex":1,"childSelector":"ifx-table"},{"kind":"value","argKey":"cols","propKey":"cols","attrKey":"cols","controlType":"","initialValue":"[{\"headerName\":\"ID\",\"field\":\"id\",\"sortable\":true,\"sort\":\"desc\",\"unSortIcon\":true},{\"headerName\":\"Item\",\"field\":\"item\",\"sortable\":true,\"unSortIcon\":true},{\"headerName\":\"Price\",\"field\":\"price\"},{\"headerName\":\"Date\",\"field\":\"date\"}]","childSelector":"ifx-table"},{"kind":"value","argKey":"rows","propKey":"rows","attrKey":"rows","controlType":"","initialValue":"[{\"id\":1,\"item\":\"Item 1\",\"price\":356,\"date\":\"2025-05-11\"},{\"id\":2,\"item\":\"Item 2\",\"price\":55,\"date\":\"2025-03-26\"},{\"id\":3,\"item\":\"Item 3\",\"price\":24},{\"id\":4,\"item\":\"Item 4\",\"price\":874,\"date\":\"2025-04-30\"},{\"id\":5,\"item\":\"Item 5\",\"price\":689,\"date\":\"2025-09-14\"},{\"id\":6,\"item\":\"Item 6\",\"price\":46},{\"id\":7,\"item\":\"Item 7\",\"price\":421,\"date\":\"2026-07-25\"},{\"id\":8,\"item\":\"Item 8\",\"price\":17,\"date\":\"2026-06-28\"},{\"id\":9,\"item\":\"Item 9\",\"price\":752},{\"id\":10,\"item\":\"Item 10\",\"price\":73,\"date\":\"2026-01-27\"},{\"id\":11,\"item\":\"Item 11\",\"price\":94,\"date\":\"2026-10-31\"},{\"id\":12,\"item\":\"Item 12\",\"price\":846}]","childSelector":"ifx-table"},{"kind":"options","argKey":"variant","propKey":"variant","attrKey":"variant","options":["default","zebra"],"initialIndex":0,"childSelector":"ifx-table"}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-basic-table-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-basic-table-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-basic-table-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            // Emitted when sort order changes.
        document.querySelector('#ifx-table-example-defaultstate ifx-table')?.addEventListener('ifxSortChange', (event) => {
          console.log('ifxSortChange:', event);
          // Add your custom handler logic here
        });

        (() => {
          const section = document.getElementById('ifx-table-example-defaultstate');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-table-example-defaultstate-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"value","argKey":"tableHeight","propKey":"tableHeight","attrKey":"table-height","controlType":"","initialValue":"auto"},{"kind":"boolean","argKey":"pagination","propKey":"pagination","attrKey":"pagination","initial":true},{"kind":"boolean","argKey":"serverSidePagination","propKey":"serverSidePagination","attrKey":"server-side-pagination","initial":false},{"kind":"value","argKey":"paginationItemsPerPage","propKey":"paginationItemsPerPage","attrKey":"pagination-items-per-page","controlType":"","initialValue":"[{\"value\":\"10\",\"selected\":true}, {\"value\":\"20\",\"selected\":false}, {\"value\":\"30\",\"selected\":false}, {\"value\":\"all\",\"selected\":false}]"},{"kind":"boolean","argKey":"showLoading","propKey":"showLoading","attrKey":"show-loading","initial":false},{"kind":"options","argKey":"rowHeight","propKey":"rowHeight","attrKey":"row-height","options":["compact","default"],"initialIndex":1},{"kind":"boolean","argKey":"enableSelection","propKey":"enableSelection","attrKey":"enable-selection","initial":false},{"kind":"options","argKey":"filterOrientation","propKey":"filterOrientation","attrKey":"filter-orientation","options":["sidebar","topbar","none"],"initialIndex":2},{"kind":"value","argKey":"cols","propKey":"cols","attrKey":"cols","controlType":"","initialValue":"[{\"headerName\":\"ID\",\"field\":\"id\",\"sortable\":true,\"sort\":\"desc\",\"unSortIcon\":true},{\"headerName\":\"Item\",\"field\":\"item\",\"sortable\":true,\"unSortIcon\":true},{\"headerName\":\"Price\",\"field\":\"price\"},{\"headerName\":\"Date\",\"field\":\"date\"}]"},{"kind":"boolean","argKey":"fitColumns","propKey":"fitColumns","attrKey":"fit-columns","initial":false},{"kind":"value","argKey":"columnMinWidth","propKey":"columnMinWidth","attrKey":"column-min-width","controlType":"","initialValue":"200"},{"kind":"value","argKey":"columnWidth","propKey":"columnWidth","attrKey":"column-width","controlType":"","initialValue":"100"},{"kind":"value","argKey":"rows","propKey":"rows","attrKey":"rows","controlType":"","initialValue":"[{\"id\":\"1\",\"item\":\"Item 1\",\"price\":356,\"date\":\"2025-06-25\"},{\"id\":\"2\",\"item\":\"Item 2\",\"price\":55,\"date\":\"2025-03-26\"},{\"id\":\"3\",\"item\":\"Item 3\",\"price\":24},{\"id\":\"4\",\"item\":\"x\",\"price\":874},{\"id\":\"5\",\"item\":\"x\",\"price\":689},{\"id\":\"6\",\"item\":\"x\",\"price\":46},{\"id\":\"7\",\"item\":\"Item 7\",\"price\":421},{\"id\":\"8\",\"item\":\"Item 8\",\"price\":17},{\"id\":\"9\",\"item\":\"x\",\"price\":752},{\"id\":\"10\",\"item\":\"Item 10\",\"price\":73},{\"id\":\"11\",\"item\":\"x\",\"price\":94}]"},{"kind":"options","argKey":"variant","propKey":"variant","attrKey":"variant","options":["default","zebra"],"initialIndex":0},{"kind":"value","argKey":"headline","propKey":"headline","attrKey":"headline","controlType":"","initialValue":"Matching results"},{"kind":"value","argKey":"headlineNumber","propKey":"headlineNumber","attrKey":"headline-number","controlType":"","initialValue":"0"}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-table-example-defaultstate"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-table-example-defaultstate"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-table-example-defaultstate"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            // Emitted when the active tab changes (e.g., user selects a different tab).
        document.querySelector('#ifx-tabs-example ifx-tabs')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

        // Emitted when tab header triggers a change (selection or property updates).
        document.querySelector('#ifx-tabs-example ifx-tabs')?.addEventListener('tabHeaderChange', (event) => {
          console.log('tabHeaderChange:', event);
          // Add your custom handler logic here
        });

        (() => {
          const section = document.getElementById('ifx-tabs-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-tabs-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"options","argKey":"orientation","propKey":"orientation","attrKey":"orientation","options":["horizontal","vertical"],"initialIndex":0},{"kind":"options","argKey":"icon","propKey":"icon","attrKey":"icon","options":["cartF16","ids16","addressBook16","advanced16","ai16","airplane16","antenna16","apartmentBuilding16","applications16","archive16","arrowDown16","arrowLeft16","arrowRight16","arrowTriangleDiagonal16","arrowTriangleDown16","arrowTriangleHorizontal16","arrowTriangleLeft16","arrowTriangleRight16","arrowTriangleUp16","arrowTriangleVertikal16","arrowUp16","assembledProduct16","attachment16","audioDescription16","availability16","award16","ban16","barGraph16","barGraphLinear16","barGraphX16","barcode16","batteryCharging16","beginner16","bell16","bellF16","bellX16","bike16","binoculars16","block16","blocks16","bluetooth16","board16","book16","bookBookmark16","bookOpen16","bookmark16","bookmarkF16","box16","braille16","briefcase16","bug16","bulletList16","cAdd16","cAddF16","cCheck16","cCheckF16","cDelete16","cDeleteF16","cInfo16","cInfoF16","cQuestion16","cQuestionF16","cRemove16","cRemoveF16","cWarning16","cWarningF16","calculator16","calendar16","calendarCheck16","calendarHeart16","calendarPlus16","camera16","car16","carLights16","card16","cart16","changeStatus16","charging16","chart16","chat16","check16","checkList16","checkedOutOther16","checkedOutYou16","chemistry16","chevronDown16","chevronLeft16","chevronRight16","chevronUp16","chip16","chipAi16","chipDip16","chips16","chocolateMenu16","chocolateMenuActive16","clipboard16","clipboardCheck16","clipboardMedical16","clock16","cloud16","cloudUploadDownload16","coach16","code16","cogwheel16","coins16","comment16","community16","configure16","contact16","copy16","copyright16","cornerArrowDownRight16","cross16","cssGidEuResidencePermit16","curvedArrowLeft16","curvedArrowRight16","cutlery16","dashboard16","database16","delete16","deleteForever16","deleteText16","desk16","desktop16","desktopScreen16","dot16","doubleChevronDown16","doubleChevronLeft16","doubleChevronRight16","doubleChevronUp16","download16","downloadCheck16","downloadPlus16","dragArrows16","dragIndicator16","duplicate16","eid16","editor16","elearning16","enlarge16","euc16","facebook","factory16","fairyWand16","feedbackSupport16","file16","fileAac16","fileAvi16","fileCss16","fileCsv16","fileDoc16","fileDocx16","fileEps16","fileExe16","fileGif16","fileHtml16","fileJpg16","fileJs16","fileJson16","fileMkv16","fileMov16","fileMp316","fileMp416","fileMpg16","fileOtf16","filePdf16","filePng16","filePpt16","filePptx16","fileRar16","fileRtf16","fileSap16","fileSql16","fileStp16","fileSvg16","fileText16","fileTxt16","fileVdf16","fileVdn16","fileVnd16","fileXlsx16","fileXml16","fileZip16","filter16","filterActive16","finance16","firewall16","flag16","flagF16","floppyDisk16","floppyDisks16","folder16","folderAdd16","folderEmpty16","folderOpen16","folderRemove16","fruitCrate16","gallery16","genericDiode16","github","glasses16","globe16","google","graduation16","grid16","gridLayout16","group16","gym16","halogenFree16","handshake16","happyBaby16","hashMark16","heading116","heading216","heading316","heading416","heading516","heading616","headset16","hide16","highReliablity16","history16","home16","hospital16","hospitalBed16","hourglass16","hyperlink16","image16","inbox16","instagram","insurance16","intermediate16","isolator16","key16","language16","laptop16","launch16","layers16","layout16","leadFree16","leaf16","license16","lifebuoy16","lightEmittingDiode16","lineGraph16","link16","linkedin","list16","listCheck16","listEdit16","listPlus16","listUser16","lock16","lockF16","logistics16","logout16","mail16","mapPin16","maximize16","medal16","mediaEject16","mediaPause16","mediaPlay16","mediaRecord16","mediaStop16","megaphone16","menu16","menuLeft16","menuRight16","microcontroller16","microcontrollerErase16","microcontrollerProgram16","microcontrollerSave16","microcontrollerVerify16","microphone16","minus16","mobileChat16","module16","money16","moon16","moonFilled16","more16","mouseCursor16","mouseCursorPointer16","mouseCursorText16","multiLineGraph16","myHr16","network16","orderedList16","organigram16","package16","paragraphs16","park16","passport16","pen16","people16","phone16","phoneCall16","pin16","pinF16","plus16","poll16","power16","preferences16","present16","preview16","printer16","procurement16","project16","protection16","qrCode16","qualified16","questionMark16","quote16","rateDown16","rateUp16","refresh16","reload16","reply16","restore16","roboticArm16","rocket16","rss16","sWarning16","sad16","sample16","satelite16","scale16","scissors16","search16","send16","server16","share16","shield16","shieldSettings16","show16","shuffle16","sidebarLeft16","sidebarRight16","simulation16","skipToBeginning16","skipToEnd16","smartphone16","smile16","snow16","software16","solution16","sound16","speaker16","splitView16","staircaseGraph16","star16","starF16","streetView16","stroller16","subscript16","superscript16","swapHorizontal16","swapVertical16","table16","tableX16","tag16","team16","technology16","temperature16","textBold16","textColor16","textItalic16","thumbDown16","thumbUp16","tool16","training16","tram16","transceiver16","translation16","treeStructure16","trendDown16","trendUp16","ungroup16","unlink16","unlocked16","unorderedList16","upload16","usb16","usbRemove16","usbToggle16","user16","userAdd16","userAdded16","userPin16","userRemove16","verified16","video16","videoCam16","videoCamX16","viewReplacement16","volumeDown16","volumeMute16","volumeUp16","wafer16","warning16","warningCritical16","warningCriticalF16","warningF16","waves16","webinar16","webpage16","wechat","weibo","wheelchair16","wifi16","windows16","xing","youku","youtube","zhihu","zoomIn16","zoomOut16"],"initialIndex":0,"childSelector":"ifx-tab"},{"kind":"boolean","argKey":"fullWidth","propKey":"fullWidth","attrKey":"full-width","initial":false},{"kind":"options","argKey":"iconPosition","propKey":"iconPosition","attrKey":"icon-position","options":["left","right"],"initialIndex":0,"childSelector":"ifx-tab"},{"kind":"value","argKey":"activeTabIndex","propKey":"activeTabIndex","attrKey":"active-tab-index","controlType":"","initialValue":"0"},{"kind":"value","argKey":"header","propKey":"header","attrKey":"header","controlType":"text","initialValue":"Tab","childSelector":"ifx-tab"},{"kind":"value","argKey":"subline","propKey":"subline","attrKey":"subline","controlType":"text","initialValue":"","childSelector":"ifx-tab"},{"kind":"boolean","argKey":"disabled","propKey":"disabled","attrKey":"disabled","initial":false,"childSelector":"ifx-tab"},{"kind":"value","argKey":"label","propKey":"label","attrKey":"label","controlType":"text","initialValue":"","childSelector":"ifx-tab"},{"kind":"value","argKey":"number","propKey":"number","attrKey":"number","controlType":"","initialValue":"0","childSelector":"ifx-tab"},{"kind":"boolean","argKey":"positionSticky","propKey":"positionSticky","attrKey":"position-sticky","initial":false,"childSelector":"ifx-tab"}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-tabs-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-tabs-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-tabs-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            // Fired when the user types or the value changes.
        document.querySelector('#ifx-text-field-example ifx-text-field')?.addEventListener('ifxInput', (event) => {
          console.log('ifxInput:', event);
          // Add your custom handler logic here
        });

        (() => {
          const section = document.getElementById('ifx-text-field-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-text-field-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"value","argKey":"label","propKey":"label","attrKey":"label","controlType":"","initialValue":"Label"},{"kind":"boolean","argKey":"error","propKey":"error","attrKey":"error","initial":false},{"kind":"boolean","argKey":"disabled","propKey":"disabled","attrKey":"disabled","initial":false},{"kind":"options","argKey":"size","propKey":"size","attrKey":"size","options":["s","m"],"initialIndex":1},{"kind":"options","argKey":"icon","propKey":"icon","attrKey":"icon","options":["cartF16","ids16","addressBook16","advanced16","ai16","airplane16","antenna16","apartmentBuilding16","applications16","archive16","arrowDown16","arrowLeft16","arrowRight16","arrowTriangleDiagonal16","arrowTriangleDown16","arrowTriangleHorizontal16","arrowTriangleLeft16","arrowTriangleRight16","arrowTriangleUp16","arrowTriangleVertikal16","arrowUp16","assembledProduct16","attachment16","audioDescription16","availability16","award16","ban16","barGraph16","barGraphLinear16","barGraphX16","barcode16","batteryCharging16","beginner16","bell16","bellF16","bellX16","bike16","binoculars16","block16","blocks16","bluetooth16","board16","book16","bookBookmark16","bookOpen16","bookmark16","bookmarkF16","box16","braille16","briefcase16","bug16","bulletList16","cAdd16","cAddF16","cCheck16","cCheckF16","cDelete16","cDeleteF16","cInfo16","cInfoF16","cQuestion16","cQuestionF16","cRemove16","cRemoveF16","cWarning16","cWarningF16","calculator16","calendar16","calendarCheck16","calendarHeart16","calendarPlus16","camera16","car16","carLights16","card16","cart16","changeStatus16","charging16","chart16","chat16","check16","checkList16","checkedOutOther16","checkedOutYou16","chemistry16","chevronDown16","chevronLeft16","chevronRight16","chevronUp16","chip16","chipAi16","chipDip16","chips16","chocolateMenu16","chocolateMenuActive16","clipboard16","clipboardCheck16","clipboardMedical16","clock16","cloud16","cloudUploadDownload16","coach16","code16","cogwheel16","coins16","comment16","community16","configure16","contact16","copy16","copyright16","cornerArrowDownRight16","cross16","cssGidEuResidencePermit16","curvedArrowLeft16","curvedArrowRight16","cutlery16","dashboard16","database16","delete16","deleteForever16","deleteText16","desk16","desktop16","desktopScreen16","dot16","doubleChevronDown16","doubleChevronLeft16","doubleChevronRight16","doubleChevronUp16","download16","downloadCheck16","downloadPlus16","dragArrows16","dragIndicator16","duplicate16","eid16","editor16","elearning16","enlarge16","euc16","facebook","factory16","fairyWand16","feedbackSupport16","file16","fileAac16","fileAvi16","fileCss16","fileCsv16","fileDoc16","fileDocx16","fileEps16","fileExe16","fileGif16","fileHtml16","fileJpg16","fileJs16","fileJson16","fileMkv16","fileMov16","fileMp316","fileMp416","fileMpg16","fileOtf16","filePdf16","filePng16","filePpt16","filePptx16","fileRar16","fileRtf16","fileSap16","fileSql16","fileStp16","fileSvg16","fileText16","fileTxt16","fileVdf16","fileVdn16","fileVnd16","fileXlsx16","fileXml16","fileZip16","filter16","filterActive16","finance16","firewall16","flag16","flagF16","floppyDisk16","floppyDisks16","folder16","folderAdd16","folderEmpty16","folderOpen16","folderRemove16","fruitCrate16","gallery16","genericDiode16","github","glasses16","globe16","google","graduation16","grid16","gridLayout16","group16","gym16","halogenFree16","handshake16","happyBaby16","hashMark16","heading116","heading216","heading316","heading416","heading516","heading616","headset16","hide16","highReliablity16","history16","home16","hospital16","hospitalBed16","hourglass16","hyperlink16","image16","inbox16","instagram","insurance16","intermediate16","isolator16","key16","language16","laptop16","launch16","layers16","layout16","leadFree16","leaf16","license16","lifebuoy16","lightEmittingDiode16","lineGraph16","link16","linkedin","list16","listCheck16","listEdit16","listPlus16","listUser16","lock16","lockF16","logistics16","logout16","mail16","mapPin16","maximize16","medal16","mediaEject16","mediaPause16","mediaPlay16","mediaRecord16","mediaStop16","megaphone16","menu16","menuLeft16","menuRight16","microcontroller16","microcontrollerErase16","microcontrollerProgram16","microcontrollerSave16","microcontrollerVerify16","microphone16","minus16","mobileChat16","module16","money16","moon16","moonFilled16","more16","mouseCursor16","mouseCursorPointer16","mouseCursorText16","multiLineGraph16","myHr16","network16","orderedList16","organigram16","package16","paragraphs16","park16","passport16","pen16","people16","phone16","phoneCall16","pin16","pinF16","plus16","poll16","power16","preferences16","present16","preview16","printer16","procurement16","project16","protection16","qrCode16","qualified16","questionMark16","quote16","rateDown16","rateUp16","refresh16","reload16","reply16","restore16","roboticArm16","rocket16","rss16","sWarning16","sad16","sample16","satelite16","scale16","scissors16","search16","send16","server16","share16","shield16","shieldSettings16","show16","shuffle16","sidebarLeft16","sidebarRight16","simulation16","skipToBeginning16","skipToEnd16","smartphone16","smile16","snow16","software16","solution16","sound16","speaker16","splitView16","staircaseGraph16","star16","starF16","streetView16","stroller16","subscript16","superscript16","swapHorizontal16","swapVertical16","table16","tableX16","tag16","team16","technology16","temperature16","textBold16","textColor16","textItalic16","thumbDown16","thumbUp16","tool16","training16","tram16","transceiver16","translation16","treeStructure16","trendDown16","trendUp16","ungroup16","unlink16","unlocked16","unorderedList16","upload16","usb16","usbRemove16","usbToggle16","user16","userAdd16","userAdded16","userPin16","userRemove16","verified16","video16","videoCam16","videoCamX16","viewReplacement16","volumeDown16","volumeMute16","volumeUp16","wafer16","warning16","warningCritical16","warningCriticalF16","warningF16","waves16","webinar16","webpage16","wechat","weibo","wheelchair16","wifi16","windows16","xing","youku","youtube","zhihu","zoomIn16","zoomOut16"],"initialIndex":0},{"kind":"boolean","argKey":"success","propKey":"success","attrKey":"success","initial":false},{"kind":"value","argKey":"placeholder","propKey":"placeholder","attrKey":"placeholder","controlType":"","initialValue":"Placeholder"},{"kind":"boolean","argKey":"readOnly","propKey":"readOnly","attrKey":"read-only","initial":false},{"kind":"value","argKey":"caption","propKey":"caption","attrKey":"caption","controlType":"","initialValue":"Caption"},{"kind":"boolean","argKey":"required","propKey":"required","attrKey":"required","initial":true},{"kind":"value","argKey":"name","propKey":"name","attrKey":"name","controlType":"","initialValue":"text-field"},{"kind":"boolean","argKey":"showDeleteIcon","propKey":"showDeleteIcon","attrKey":"show-delete-icon","initial":false},{"kind":"value","argKey":"maxlength","propKey":"maxlength","attrKey":"maxlength","controlType":"number","initialValue":0},{"kind":"value","argKey":"value","propKey":"value","attrKey":"value","controlType":"text","initialValue":""},{"kind":"value","argKey":"internalId","propKey":"internalId","attrKey":"internal-id","controlType":"text","initialValue":"text-field"},{"kind":"value","argKey":"autocomplete","propKey":"autocomplete","attrKey":"autocomplete","controlType":"text","initialValue":"on"},{"kind":"options","argKey":"type","propKey":"type","attrKey":"type","options":["text","password"],"initialIndex":0}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-text-field-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-text-field-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-text-field-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            // Fired when the textarea value changes.
        document.querySelector('#ifx-textarea-example ifx-textarea')?.addEventListener('ifxInput', (event) => {
          console.log('ifxInput:', event);
          // Add your custom handler logic here
        });

        (() => {
          const section = document.getElementById('ifx-textarea-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-textarea-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"value","argKey":"caption","propKey":"caption","attrKey":"caption","controlType":"","initialValue":"Caption text, description, error notification"},{"kind":"value","argKey":"cols","propKey":"cols","attrKey":"cols","controlType":"number","initialValue":43},{"kind":"boolean","argKey":"disabled","propKey":"disabled","attrKey":"disabled","initial":false},{"kind":"boolean","argKey":"error","propKey":"error","attrKey":"error","initial":false},{"kind":"value","argKey":"label","propKey":"label","attrKey":"label","controlType":"","initialValue":"Label Text"},{"kind":"value","argKey":"maxlength","propKey":"maxlength","attrKey":"maxlength","controlType":"","initialValue":""},{"kind":"value","argKey":"name","propKey":"name","attrKey":"name","controlType":"","initialValue":"textarea"},{"kind":"value","argKey":"placeholder","propKey":"placeholder","attrKey":"placeholder","controlType":"","initialValue":"Placeholder"},{"kind":"boolean","argKey":"required","propKey":"required","attrKey":"required","initial":true},{"kind":"boolean","argKey":"readOnly","propKey":"readOnly","attrKey":"read-only","initial":false},{"kind":"options","argKey":"resize","propKey":"resize","attrKey":"resize","options":["both","vertical","horizontal","none"],"initialIndex":0},{"kind":"value","argKey":"rows","propKey":"rows","attrKey":"rows","controlType":"","initialValue":"5"},{"kind":"value","argKey":"value","propKey":"value","attrKey":"value","controlType":"","initialValue":""},{"kind":"options","argKey":"wrap","propKey":"wrap","attrKey":"wrap","options":["soft","hard","off"],"initialIndex":0},{"kind":"boolean","argKey":"fullWidth","propKey":"fullWidth","attrKey":"full-width","initial":false}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-textarea-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-textarea-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-textarea-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();

            (() => {
          const section = document.getElementById('ifx-tooltip-example');
          if (!section) return;

          const root = section.querySelector('.demo > *');
          const codeNode = section.querySelector('#ifx-tooltip-example-code');
          if (!(root instanceof Element) || !(codeNode instanceof HTMLElement)) return;

      		const controls = [{"kind":"value","argKey":"text","propKey":"text","attrKey":"text","controlType":"text","initialValue":"Hi, I'm a tooltip"},{"kind":"options","argKey":"icon","propKey":"icon","attrKey":"icon","options":["cartF16","ids16","addressBook16","advanced16","ai16","airplane16","antenna16","apartmentBuilding16","applications16","archive16","arrowDown16","arrowLeft16","arrowRight16","arrowTriangleDiagonal16","arrowTriangleDown16","arrowTriangleHorizontal16","arrowTriangleLeft16","arrowTriangleRight16","arrowTriangleUp16","arrowTriangleVertikal16","arrowUp16","assembledProduct16","attachment16","audioDescription16","availability16","award16","ban16","barGraph16","barGraphLinear16","barGraphX16","barcode16","batteryCharging16","beginner16","bell16","bellF16","bellX16","bike16","binoculars16","block16","blocks16","bluetooth16","board16","book16","bookBookmark16","bookOpen16","bookmark16","bookmarkF16","box16","braille16","briefcase16","bug16","bulletList16","cAdd16","cAddF16","cCheck16","cCheckF16","cDelete16","cDeleteF16","cInfo16","cInfoF16","cQuestion16","cQuestionF16","cRemove16","cRemoveF16","cWarning16","cWarningF16","calculator16","calendar16","calendarCheck16","calendarHeart16","calendarPlus16","camera16","car16","carLights16","card16","cart16","changeStatus16","charging16","chart16","chat16","check16","checkList16","checkedOutOther16","checkedOutYou16","chemistry16","chevronDown16","chevronLeft16","chevronRight16","chevronUp16","chip16","chipAi16","chipDip16","chips16","chocolateMenu16","chocolateMenuActive16","clipboard16","clipboardCheck16","clipboardMedical16","clock16","cloud16","cloudUploadDownload16","coach16","code16","cogwheel16","coins16","comment16","community16","configure16","contact16","copy16","copyright16","cornerArrowDownRight16","cross16","cssGidEuResidencePermit16","curvedArrowLeft16","curvedArrowRight16","cutlery16","dashboard16","database16","delete16","deleteForever16","deleteText16","desk16","desktop16","desktopScreen16","dot16","doubleChevronDown16","doubleChevronLeft16","doubleChevronRight16","doubleChevronUp16","download16","downloadCheck16","downloadPlus16","dragArrows16","dragIndicator16","duplicate16","eid16","editor16","elearning16","enlarge16","euc16","facebook","factory16","fairyWand16","feedbackSupport16","file16","fileAac16","fileAvi16","fileCss16","fileCsv16","fileDoc16","fileDocx16","fileEps16","fileExe16","fileGif16","fileHtml16","fileJpg16","fileJs16","fileJson16","fileMkv16","fileMov16","fileMp316","fileMp416","fileMpg16","fileOtf16","filePdf16","filePng16","filePpt16","filePptx16","fileRar16","fileRtf16","fileSap16","fileSql16","fileStp16","fileSvg16","fileText16","fileTxt16","fileVdf16","fileVdn16","fileVnd16","fileXlsx16","fileXml16","fileZip16","filter16","filterActive16","finance16","firewall16","flag16","flagF16","floppyDisk16","floppyDisks16","folder16","folderAdd16","folderEmpty16","folderOpen16","folderRemove16","fruitCrate16","gallery16","genericDiode16","github","glasses16","globe16","google","graduation16","grid16","gridLayout16","group16","gym16","halogenFree16","handshake16","happyBaby16","hashMark16","heading116","heading216","heading316","heading416","heading516","heading616","headset16","hide16","highReliablity16","history16","home16","hospital16","hospitalBed16","hourglass16","hyperlink16","image16","inbox16","instagram","insurance16","intermediate16","isolator16","key16","language16","laptop16","launch16","layers16","layout16","leadFree16","leaf16","license16","lifebuoy16","lightEmittingDiode16","lineGraph16","link16","linkedin","list16","listCheck16","listEdit16","listPlus16","listUser16","lock16","lockF16","logistics16","logout16","mail16","mapPin16","maximize16","medal16","mediaEject16","mediaPause16","mediaPlay16","mediaRecord16","mediaStop16","megaphone16","menu16","menuLeft16","menuRight16","microcontroller16","microcontrollerErase16","microcontrollerProgram16","microcontrollerSave16","microcontrollerVerify16","microphone16","minus16","mobileChat16","module16","money16","moon16","moonFilled16","more16","mouseCursor16","mouseCursorPointer16","mouseCursorText16","multiLineGraph16","myHr16","network16","orderedList16","organigram16","package16","paragraphs16","park16","passport16","pen16","people16","phone16","phoneCall16","pin16","pinF16","plus16","poll16","power16","preferences16","present16","preview16","printer16","procurement16","project16","protection16","qrCode16","qualified16","questionMark16","quote16","rateDown16","rateUp16","refresh16","reload16","reply16","restore16","roboticArm16","rocket16","rss16","sWarning16","sad16","sample16","satelite16","scale16","scissors16","search16","send16","server16","share16","shield16","shieldSettings16","show16","shuffle16","sidebarLeft16","sidebarRight16","simulation16","skipToBeginning16","skipToEnd16","smartphone16","smile16","snow16","software16","solution16","sound16","speaker16","splitView16","staircaseGraph16","star16","starF16","streetView16","stroller16","subscript16","superscript16","swapHorizontal16","swapVertical16","table16","tableX16","tag16","team16","technology16","temperature16","textBold16","textColor16","textItalic16","thumbDown16","thumbUp16","tool16","training16","tram16","transceiver16","translation16","treeStructure16","trendDown16","trendUp16","ungroup16","unlink16","unlocked16","unorderedList16","upload16","usb16","usbRemove16","usbToggle16","user16","userAdd16","userAdded16","userPin16","userRemove16","verified16","video16","videoCam16","videoCamX16","viewReplacement16","volumeDown16","volumeMute16","volumeUp16","wafer16","warning16","warningCritical16","warningCriticalF16","warningF16","waves16","webinar16","webpage16","wechat","weibo","wheelchair16","wifi16","windows16","xing","youku","youtube","zhihu","zoomIn16","zoomOut16"],"initialIndex":0},{"kind":"options","argKey":"position","propKey":"position","attrKey":"position","options":["auto","bottom-start","top-start","left","bottom-end","top-end","right","bottom","top"],"initialIndex":0},{"kind":"options","argKey":"variant","propKey":"variant","attrKey":"variant","options":["compact","dismissible","extended"],"initialIndex":0},{"kind":"value","argKey":"header","propKey":"header","attrKey":"header","controlType":"text","initialValue":"Tooltip headline"},{"kind":"value","argKey":"ariaLabelText","propKey":"ariaLabelText","attrKey":"aria-label-text","controlType":"text","initialValue":"Tooltip with important information"}];
      		const rootTextControl = null;

      	const state = {};
          controls.forEach((control) => {
            if (control.kind === 'options') {
              const options = control.options || [];
              const idx = control.initialIndex ?? 0;
              state[control.propKey] = options[idx] ?? '';
      			} else if (control.kind === 'value') {
      				state[control.propKey] = control.initialValue ?? '';
            } else {
              state[control.propKey] = Boolean(control.initial);
            }
          });

      	const escapeHtml = (value) => value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          const renderCode = () => {
            codeNode.innerHTML = escapeHtml(root.outerHTML);
      	const Prism = globalThis.Prism;
      	Prism?.highlightElement?.(codeNode);
          };

      		const renderButtonContent = () => {
      			if (root.tagName !== 'IFX-BUTTON') return;
      			const label = rootTextControl ? String(state[rootTextControl] ?? '') : root.textContent ?? '';
      			const icon = String(state.icon ?? '');
      			const iconPosition = String(state.iconPosition ?? 'left');
      			root.replaceChildren();
      			if (icon && iconPosition === 'left') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      			root.append(document.createTextNode(label));
      			if (icon && iconPosition === 'right') {
      				const iconEl = document.createElement('ifx-icon');
      				iconEl.setAttribute('icon', icon);
      				root.append(iconEl);
      			}
      		};

          const renderState = () => {
            controls.forEach((control) => {
              const stateNode = section.querySelector(
                '[data-control-state="ifx-tooltip-example"][data-control-key="' + control.propKey + '"]',
              );
              if (stateNode) stateNode.textContent = String(state[control.propKey]);
            });
          };

          const applyState = () => {
            controls.forEach((control) => {
      				if (rootTextControl && control.propKey === rootTextControl) {
      					return;
      				}
      				// Generic: propagate to child elements when the control has a childSelector
      				if (control.childSelector) {
      					root.querySelectorAll(control.childSelector).forEach((item) => {
      						item.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey] ?? ''));
      					});
      				}
      				if (root.tagName === 'IFX-BUTTON' && (control.propKey === 'icon' || control.propKey === 'iconPosition')) {
      					return;
      				}
      				root.setAttribute(String(control.attrKey || control.propKey), String(state[control.propKey]));
            });
      			if (root.tagName === 'IFX-BUTTON') {
      				renderButtonContent();
      			} else if (rootTextControl) {
      				root.textContent = String(state[rootTextControl] ?? '');
      			}
            renderState();
            renderCode();
          };

      		section.querySelectorAll('ifx-button[data-control-target="ifx-tooltip-example"]').forEach((button) => {
            button.addEventListener('click', () => {
              const key = button.getAttribute('data-control-key');
              if (!key) return;
              const control = controls.find((c) => c.propKey === key);
              if (!control) return;

              if (control.kind === 'options') {
                const options = control.options || [];
                const current = state[key];
                const currentIndex = Math.max(0, options.findIndex((opt) => opt === current));
                state[key] = options[(currentIndex + 1) % options.length];
      				} else if (control.kind === 'value') {
      					return;
              } else {
                state[key] = !Boolean(state[key]);
              }

              applyState();
            });
          });

      		section.querySelectorAll('ifx-text-field[data-control-input="ifx-tooltip-example"]').forEach((inputEl) => {
      			const handleInput = (event) => {
      				const key = inputEl.getAttribute('data-control-key');
      				if (!key) return;
      				const control = controls.find((c) => c.propKey === key);
      				if (!control || control.kind !== 'value') return;

      				const rawValue = event?.detail?.value ?? inputEl.value ?? '';
      				if (control.controlType === 'number' || control.controlType === 'range') {
      					state[key] = Number(rawValue);
      				} else {
      					state[key] = String(rawValue);
      				}

      				applyState();
      			};

      			inputEl.addEventListener('input', handleInput);
      			inputEl.addEventListener('ifxInput', handleInput);
      		});

          applyState();
        })();


      			// --- Generated Navigation (hash-based) ---
      			const allComponentsId = "all-components";
      			const defaultId = window.__ifxDefaultExampleId || "ifx-accordion-example";

      			const getHashId = () => (window.location.hash ? window.location.hash.slice(1) : "");

      			const setActive = (id) => {
      				const sections = document.querySelectorAll("section.component-example");
      				sections.forEach((s) => {
      					const shouldShow = id === allComponentsId || s.id === id;
      					s.style.display = shouldShow ? "" : "none";
      				});

      				// Prism highlight the active section
      				const Prism = globalThis.Prism;
      				const activeSection = document.getElementById(id);
      				if (id === allComponentsId && Prism?.highlightAll) {
      					Prism.highlightAll();
      				} else if (Prism?.highlightAllUnder && activeSection) {
      					Prism.highlightAllUnder(activeSection);
      				} else if (Prism?.hightlightAll) {
      					Prism.highlightAll();
      				}
      			};

      			const run = () => {
      				const next = getHashId();
      				if (next) {
      					setActive(next);
      				} else {
      					window.location.hash = "#ifx-accordion-example";
      					setActive(defaultId);
      				}
      			};

      			if (document.readyState === "loading") {
      				document.addEventListener("DOMContentLoaded", run, { once: true});
      			} else {
      				run();
      			}

      			window.addEventListener("hashchange", run);
      			window.addEventListener("popstate", run);

      			// Some navbar implementations update the URL without firing "hashchange".
      			// So also react to clicks on items that have href="#..."
      			document.addEventListener(
      			  "click",
      			  (e) => {
      			    const target = e.target;
      			    if (!(target instanceof Element)) return;

      			    const item = target.closest("ifx-navbar-item");
      			    if (!item) return;

      			    const href = item.getAttribute("href") || "";
      			    if (!href.startsWith("#")) return;

      			    // allow the component to update the URL first
      			    setTimeout(run, 0);
      			  },
      			  true,
      			);

      /* </AUTO-GENERATED-SCRIPTS> */
      
      // Manual Examples - Modal
      const modal = document.getElementById('modal');
      const openButton = document.getElementById('open-modal');
      
      openButton?.addEventListener('click', () => {
        if (modal) {
          modal.opened = true;
        }
      });
      
      modal?.addEventListener('ifxOpen', (event) => {
        console.log('ifxOpen:', event.detail);
      });
      
      modal?.addEventListener('ifxClose', (event) => {
        console.log('ifxClose:', event.detail);
      });
    